/* La Salopette Chat Widget (vanilla, no deps)
 * - Bubble bottom-right, never opens auto.
 * - Two views: Home (cards) and Chat (conversation).
 * - localStorage session persistence.
 * - Respects Pandectes cookie consent if present.
 */
(function () {
  "use strict";

  // ====== Auto-detect market from hostname ======
  // Si le widget est embarque sur la-salopette.nl, on envoie market=nl
  // pour que Claude utilise les bonnes URLs et la bonne langue.
  function detectMarket() {
    try {
      var h = (window.location.hostname || "").toLowerCase();
      var map = [
        ["die-latzhose.at", "at"],
        ["die-latzhose.com", "de"],
        ["die-latzhose.de", "de"],
        ["la-salopette.fr", "fr"],
        ["la-salopette.it", "it"],
        ["la-salopette.nl", "nl"],
        ["la-salopette.be", "be"],
        ["la-salopette.es", "es"],
        ["la-salopette.ch", "ch"],
        ["la-salopette.uk", "uk"],
        ["la-salopette.co.uk", "uk"],
        ["la-salopette.ca", "ca"],
        ["la-salopette.us", "us"],
        ["la-salopette.dk", "dk"],
        ["la-salopette.se", "se"]
      ];
      for (var i = 0; i < map.length; i++) {
        if (h.indexOf(map[i][0]) !== -1) return map[i][1];
      }
    } catch (e) {}
    return "fr";
  }

  // Detect Shopify locale if exposed by theme
  function detectLocale() {
    try {
      if (window.Shopify && window.Shopify.locale) return String(window.Shopify.locale).toLowerCase().slice(0,2);
      var html = document.documentElement.getAttribute("lang");
      if (html) return html.toLowerCase().slice(0,2);
    } catch (e) {}
    return null;
  }

  var DETECTED_MARKET = detectMarket();
  var DETECTED_LOCALE = detectLocale() || DETECTED_MARKET;
  // 📦 Accroche Express adaptee au PAYS du client (Arnaud 2026-06-25) : delai FR=2-3j, autres EU=3-6j ouvrés ;
  // drapeau du client a la FIN ; "atelier Miramas" mentionne UNIQUEMENT en FR (un non-francophone ne sait pas
  // ce qu'est Miramas). Tokens {d}=delai {f}=drapeau substitues au moment du tir (fire).
  var MK_FLAG = { fr: "🇫🇷", be: "🇧🇪", ch: "🇨🇭", de: "🇩🇪", at: "🇦🇹", it: "🇮🇹", es: "🇪🇸", nl: "🇳🇱", uk: "🇬🇧", us: "🇺🇸", ca: "🇨🇦", dk: "🇩🇰", se: "🇸🇪" , pl: "🇵🇱" };
  var EXP_DELAY = (DETECTED_MARKET === "fr") ? "2-3" : "3-6";
  var EXP_FLAG = MK_FLAG[DETECTED_MARKET] || "";

  // Brand swap : Die Latzhose® pour DE + AT + Suisse ALLEMANDE (.ch avec locale/path de)
  // La Salopette pour tout le reste (FR/NL/DK/SE/IT/ES/BE/UK/CA/US + CH fr/it)
  function isGermanBrand() {
    if (DETECTED_MARKET === "de" || DETECTED_MARKET === "at") return true;
    if (DETECTED_MARKET === "ch") {
      var path = (window.location.pathname || "").toLowerCase();
      // Shopify CH multi-locale = path-based : /de, /de-ch ...
      if (DETECTED_LOCALE === "de" || path.indexOf("/de") === 0) return true;
    }
    return false;
  }
  var _GERMAN_BRAND = isGermanBrand();
  var BRAND_FULL = _GERMAN_BRAND ? "Die Latzhose®" : "La Salopette";
  var BRAND_SHORT = _GERMAN_BRAND ? "DL" : "LS";

  // Localized greeting/sub per market (minimal fallback, panel labels stay FR by default)
  var GREETINGS = {
    fr: { title: "Hey 👋", sub: "On répond généralement en quelques secondes 😄" },
    de: { title: "Hallo 👋", sub: "Wir antworten meistens in wenigen Sekunden 😄" },
    at: { title: "Hallo 👋", sub: "Wir antworten meistens in wenigen Sekunden 😄" },
    it: { title: "Ciao 👋", sub: "Di solito rispondiamo in pochi secondi 😄" },
    es: { title: "Hola 👋", sub: "Solemos responder en pocos segundos 😄" },
    nl: { title: "Hoi 👋", sub: "We antwoorden meestal binnen enkele seconden 😄" },
    uk: { title: "Hey 👋", sub: "We usually reply within a few seconds 😄" },
    ca: { title: "Hey 👋", sub: "We usually reply within a few seconds 😄" },
    us: { title: "Hey 👋", sub: "We usually reply within a few seconds 😄" },
    be: { title: "Hey 👋", sub: "On répond généralement en quelques secondes 😄" },
    ch: { title: "Hey 👋", sub: "On répond généralement en quelques secondes 😄" },
    dk: { title: "Hej 👋", sub: "Vi svarer typisk inden for få sekunder 😄" },
    se: { title: "Hej 👋", sub: "Vi svarar oftast inom några sekunder 😄" },
    pl: { title: "Cześć 👋", sub: "Zwykle odpowiadamy w kilka sekund 😄" }
  };
  var GR = GREETINGS[DETECTED_MARKET] || GREETINGS.fr;

  // ====== UI I18N : tout le panneau "équipe" suit la LANGUE du pays (Arnaud 2026-06-01) ======
  var UI_I18N = {
    fr: { role_chat: "Chat live", role_sav: "SAV email", role_atelier: "Atelier Miramas", online: "En ligne maintenant", offline: "Hors ligne", online_s: "en ligne", offline_s: "hors ligne", team: "On vous écoute 💬", see_hours: "Voir les horaires de l'équipe", collapse: "Replier", hint_hours: "voir les horaires", tab_home: "Accueil", tab_chat: "Discuter", sched_j: "Lun-Ven 8h-22h · Sam 10h-19h", sched_l: "Lun-Ven 9h-18h", sched_b: "Lun-Sam 7h-14h", input_ph: "Tapez votre message...", attach: "Joindre une photo", see_online: "Cliquez pour voir qui est en ligne", rever_badge: "REVER 14j" },
    de: { role_chat: "Live-Chat", role_sav: "Kundenservice", role_atelier: "Werkstatt Miramas", online: "Jetzt online", offline: "Offline", online_s: "online", offline_s: "offline", team: "Wir hören Ihnen zu 💬", see_hours: "Team-Zeiten anzeigen", collapse: "Einklappen", hint_hours: "Zeiten anzeigen", tab_home: "Start", tab_chat: "Chat", sched_j: "Mo-Fr 8-22 Uhr · Sa 10-19 Uhr", sched_l: "Mo-Fr 9-18 Uhr", sched_b: "Mo-Sa 7-14 Uhr", input_ph: "Schreiben Sie Ihre Nachricht...", attach: "Foto anhängen", see_online: "Sehen, wer online ist", rever_badge: "REVER 14 Tage" },
    it: { role_chat: "Chat dal vivo", role_sav: "Assistenza email", role_atelier: "Atelier Miramas", online: "Online ora", offline: "Offline", online_s: "online", offline_s: "offline", team: "Siamo in ascolto 💬", see_hours: "Vedi gli orari del team", collapse: "Riduci", hint_hours: "vedi orari", tab_home: "Home", tab_chat: "Chatta", sched_j: "Lun-Ven 8-22 · Sab 10-19", sched_l: "Lun-Ven 9-18", sched_b: "Lun-Sab 7-14", input_ph: "Scrivi il tuo messaggio...", attach: "Allega una foto", see_online: "Vedi chi è online", rever_badge: "REVER 14gg" },
    es: { role_chat: "Chat en vivo", role_sav: "Atención email", role_atelier: "Taller Miramas", online: "En línea ahora", offline: "Desconectado", online_s: "en línea", offline_s: "desconectado", team: "Le escuchamos 💬", see_hours: "Ver el horario del equipo", collapse: "Contraer", hint_hours: "ver horario", tab_home: "Inicio", tab_chat: "Chatear", sched_j: "Lun-Vie 8-22 · Sáb 10-19", sched_l: "Lun-Vie 9-18", sched_b: "Lun-Sáb 7-14", input_ph: "Escribe tu mensaje...", attach: "Adjuntar una foto", see_online: "Ver quién está en línea", rever_badge: "REVER 14 días" },
    nl: { role_chat: "Live chat", role_sav: "Klantenservice", role_atelier: "Atelier Miramas", online: "Nu online", offline: "Offline", online_s: "online", offline_s: "offline", team: "We luisteren naar u 💬", see_hours: "Bekijk de teamuren", collapse: "Inklappen", hint_hours: "bekijk uren", tab_home: "Home", tab_chat: "Chatten", sched_j: "Ma-Vr 8-22 · Za 10-19", sched_l: "Ma-Vr 9-18", sched_b: "Ma-Za 7-14", input_ph: "Typ je bericht...", attach: "Een foto bijvoegen", see_online: "Zie wie online is", rever_badge: "REVER 14d" },
    en: { role_chat: "Live chat", role_sav: "Email support", role_atelier: "Miramas workshop", online: "Online now", offline: "Offline", online_s: "online", offline_s: "offline", team: "We're listening 💬", see_hours: "See the team's hours", collapse: "Collapse", hint_hours: "see hours", tab_home: "Home", tab_chat: "Chat", sched_j: "Mon-Fri 8-22 · Sat 10-19", sched_l: "Mon-Fri 9-18", sched_b: "Mon-Sat 7-14", input_ph: "Type your message...", attach: "Attach a photo", see_online: "See who's online", rever_badge: "REVER 14d" },
    pl: { role_chat: "Czat na żywo", role_sav: "Obsługa e-mail", role_atelier: "Atelier Miramas", online: "Teraz online", offline: "Offline", online_s: "online", offline_s: "offline", team: "Słuchamy Cię 💬", see_hours: "Zobacz godziny pracy zespołu", collapse: "Zwiń", hint_hours: "zobacz godziny", tab_home: "Start", tab_chat: "Czat", sched_j: "Pn-Pt 8-22 · Sob 10-19", sched_l: "Pn-Pt 9-18", sched_b: "Pn-Sob 7-14", input_ph: "Napisz swoją wiadomość...", attach: "Załącz zdjęcie", see_online: "Zobacz, kto jest online", rever_badge: "REVER 14 dni" }
  };
  // Langue d'affichage du widget : locale connue (de-CH->de, nl-BE->nl, en...) sinon DEFAUT du marche
  // (CH/BE -> fr, uk/us/ca -> en) au lieu de tomber en anglais. Arnaud 2026-06-01 (subdomains specials).
  var _MK_DEFLANG = { fr: "fr", be: "fr", ch: "fr", de: "de", at: "de", it: "it", es: "es", nl: "nl", uk: "en", us: "en", ca: "en", dk: "en", se: "en" , pl: "pl" };
  function _wlang() {
    if (UI_I18N[DETECTED_LOCALE]) return DETECTED_LOCALE;
    return _MK_DEFLANG[DETECTED_MARKET] || "en";
  }
  function uiL(key) {
    var m = UI_I18N[_wlang()] || UI_I18N.en;
    return m[key] || UI_I18N.en[key] || UI_I18N.fr[key];
  }
  // 💭 Quotes de personnalite par agent (tournent selon l'heure du client). Esprit salopette, perso,
  // un brin "trop sûres d'elles" : la pour donner une ame a l'equipe, pas pour vendre (Arnaud 2026-06-25).
  var AGENT_QUOTES = {
    Juliette: {
      fr: ["Toujours partante pour une balade en salopette 🌿", "💭 On prépare de grandes choses...", "Une salopette + un café et ma journée est parfaite ☕", "Posez vos questions, j'adore ça (vraiment) 💬", "Le bon modèle existe, on va le trouver ensemble 🔎", "Je connais nos coupes par cœur, testez-moi 👖", "Une hésitation sur la taille ? C'est mon rayon 📏", "Dites-moi tout, je ne juge que les mauvaises coutures 😄"],
      en: ["Always up for a stroll in dungarees 🌿", "💭 We're cooking up big things...", "Dungarees + coffee = my perfect day ☕", "Ask me anything, I genuinely love it 💬", "The right fit exists, let's find it together 🔎", "I know our cuts by heart, try me 👖", "Unsure about sizing? That's my thing 📏", "Tell me everything, I only judge bad stitching 😄"],
      de: ["Immer bereit für einen Spaziergang in Latzhose 🌿", "💭 Wir haben Großes vor...", "Latzhose + Kaffee = mein perfekter Tag ☕", "Fragen Sie mich alles, ich liebe es wirklich 💬", "Das passende Modell gibt es, wir finden es zusammen 🔎", "Ich kenne unsere Schnitte auswendig, fragen Sie mich 👖", "Unsicher bei der Größe? Das ist mein Spezialgebiet 📏", "Erzählen Sie mir alles, ich beurteile nur schlechte Nähte 😄"],
      it: ["Sempre pronta per una passeggiata in salopette 🌿", "💭 Stiamo preparando grandi cose...", "Salopette + caffè = la mia giornata perfetta ☕", "Chiedimi pure tutto, lo adoro davvero 💬", "Il modello giusto esiste, lo troviamo insieme 🔎", "Conosco i nostri tagli a memoria, mettimi alla prova 👖", "Dubbi sulla taglia? È il mio campo 📏", "Dimmi tutto, giudico solo le cuciture storte 😄"],
      es: ["Siempre lista para un paseo en peto 🌿", "💭 Estamos preparando grandes cosas...", "Peto + café = mi día perfecto ☕", "Pregúntame lo que sea, me encanta de verdad 💬", "El modelo ideal existe, lo encontramos juntos 🔎", "Me sé nuestros cortes de memoria, ponme a prueba 👖", "¿Dudas con la talla? Es lo mío 📏", "Cuéntame todo, solo juzgo las costuras malas 😄"],
      nl: ["Altijd in voor een wandeling in tuinbroek 🌿", "💭 We hebben grootse plannen...", "Tuinbroek + koffie = mijn perfecte dag ☕", "Vraag me alles, ik vind het echt leuk 💬", "Het juiste model bestaat, we vinden het samen 🔎", "Ik ken onze pasvormen uit mijn hoofd, test me 👖", "Twijfel over de maat? Dat is mijn ding 📏", "Vertel me alles, ik oordeel alleen over slechte naden 😄"]
    },
    Louise: {
      fr: ["Un client heureux, c'est ma plus belle récompense 💛", "Derrière chaque mail je mets un peu de moi ✨", "Mon super-pouvoir : transformer un souci en sourire ✌️", "J'ai toujours une solution sous le coude 🌷", "Un souci réglé avant midi, c'est ma victoire du jour ⏱️", "Je réponds comme j'aimerais qu'on me réponde 💌", "Rien ne se perd chez nous, tout se retrouve 📦", "Votre patience mérite une vraie réponse, pas un modèle type 🌼"],
      en: ["A happy customer is my favourite reward 💛", "There's a little of me in every email ✨", "My superpower: turning a worry into a smile ✌️", "I always have a solution up my sleeve 🌷", "An issue solved before noon is my win of the day ⏱️", "I reply the way I'd like to be replied to 💌", "Nothing gets lost here, everything turns up 📦", "Your patience deserves a real answer, not a template 🌼"],
      de: ["Ein zufriedener Kunde ist meine schönste Belohnung 💛", "In jeder E-Mail steckt ein bisschen von mir ✨", "Meine Superkraft: aus Sorgen ein Lächeln machen ✌️", "Ich habe immer eine Lösung parat 🌷", "Ein Problem vor Mittag gelöst, das ist mein Tagessieg ⏱️", "Ich antworte so, wie ich gerne eine Antwort bekäme 💌", "Bei uns geht nichts verloren, alles findet sich 📦", "Ihre Geduld verdient eine echte Antwort, keine Vorlage 🌼"],
      it: ["Un cliente felice è la mia ricompensa più bella 💛", "In ogni email c'è un po' di me ✨", "Il mio superpotere: trasformare un problema in un sorriso ✌️", "Ho sempre una soluzione pronta 🌷", "Un problema risolto prima di mezzogiorno è la mia vittoria ⏱️", "Rispondo come vorrei che rispondessero a me 💌", "Da noi nulla si perde, tutto si ritrova 📦", "La tua pazienza merita una risposta vera, non un modello 🌼"],
      es: ["Un cliente feliz es mi mejor recompensa 💛", "En cada correo dejo un poquito de mí ✨", "Mi superpoder: convertir un problema en una sonrisa ✌️", "Siempre tengo una solución a mano 🌷", "Un problema resuelto antes del mediodía es mi victoria ⏱️", "Respondo como me gustaría que me respondieran 💌", "Aquí no se pierde nada, todo aparece 📦", "Tu paciencia merece una respuesta real, no una plantilla 🌼"],
      nl: ["Een blije klant is mijn mooiste beloning 💛", "In elke mail stop ik een beetje van mezelf ✨", "Mijn superkracht: een zorg in een glimlach veranderen ✌️", "Ik heb altijd een oplossing achter de hand 🌷", "Een probleem opgelost voor de middag, dat is mijn overwinning ⏱️", "Ik antwoord zoals ik zelf beantwoord wil worden 💌", "Bij ons raakt niets kwijt, alles komt terecht 📦", "Uw geduld verdient een echt antwoord, geen sjabloon 🌼"]
    },
    Ben: {
      fr: ["Le denim, ça se respecte. Et ça se coud avec amour 🧵", "À l'atelier, le soleil de Miramas fait le reste ☀️", "Une couture droite, c'est une petite victoire 💪", "Je parle plus à mes machines qu'aux humains 🤫", "Une salopette bien coupée, ça se sent dès qu'on l'enfile 👌", "Ici, on plie, on repasse, on vérifie. Puis on recommence 🔁", "Le bruit de la machine, c'est ma musique préférée 🎶", "Chaque colis part avec un dernier coup d'œil de ma part 👀"],
      en: ["Denim deserves respect. And a lot of love 🧵", "At the workshop, the Miramas sun does the rest ☀️", "A straight seam is a small victory 💪", "I talk to my machines more than to people 🤫", "A well-cut pair of dungarees, you feel it the moment you put it on 👌", "Here we fold, press, check. Then do it again 🔁", "The sound of the machine is my favourite music 🎶", "Every parcel leaves after one last look from me 👀"],
      de: ["Denim verdient Respekt. Und viel Liebe 🧵", "In der Werkstatt erledigt die Sonne von Miramas den Rest ☀️", "Eine gerade Naht ist ein kleiner Sieg 💪", "Ich rede mehr mit meinen Maschinen als mit Menschen 🤫", "Eine gut geschnittene Latzhose spürt man sofort beim Anziehen 👌", "Hier wird gefaltet, gebügelt, geprüft. Und dann nochmal 🔁", "Das Geräusch der Maschine ist meine Lieblingsmusik 🎶", "Jedes Paket geht erst nach einem letzten Blick von mir raus 👀"],
      it: ["Il denim merita rispetto. E tanto amore 🧵", "In atelier, il sole di Miramas fa il resto ☀️", "Una cucitura dritta è una piccola vittoria 💪", "Parlo più con le mie macchine che con le persone 🤫", "Una salopette tagliata bene si sente appena la indossi 👌", "Qui si piega, si stira, si controlla. E poi si ricomincia 🔁", "Il rumore della macchina è la mia musica preferita 🎶", "Ogni pacco parte dopo un ultimo sguardo mio 👀"],
      es: ["El denim merece respeto. Y mucho amor 🧵", "En el taller, el sol de Miramas hace el resto ☀️", "Una costura recta es una pequeña victoria 💪", "Hablo más con mis máquinas que con las personas 🤫", "Un peto bien cortado se nota nada más ponértelo 👌", "Aquí se dobla, se plancha, se revisa. Y se repite 🔁", "El sonido de la máquina es mi música favorita 🎶", "Cada paquete sale tras un último vistazo mío 👀"],
      nl: ["Denim verdient respect. En veel liefde 🧵", "In het atelier doet de zon van Miramas de rest ☀️", "Een rechte naad is een kleine overwinning 💪", "Ik praat meer met mijn machines dan met mensen 🤫", "Een goed gesneden tuinbroek voel je zodra je hem aantrekt 👌", "Hier wordt gevouwen, gestreken, gecontroleerd. En dan weer 🔁", "Het geluid van de machine is mijn favoriete muziek 🎶", "Elk pakket vertrekt na een laatste blik van mij 👀"]
    }
  };
  function pickQuote(name) {
    var q = AGENT_QUOTES[name]; if (!q) return "";
    var arr = q[_wlang()] || q.en || q.fr; if (!arr || !arr.length) return "";
    var h = 0; try { h = new Date().getHours(); } catch (e) {}
    return arr[h % arr.length];
  }
  // Quick replies + CTA du home, localisés (le prompt envoyé doit être dans la langue du pays
  // sinon le bot répond dans la mauvaise langue). Arnaud 2026-06-01.
  var UI_QR = {
    fr: { qr: [["📏", "Quelle taille pour moi ?", "Conseil sizing en 30 secondes", "Bonjour, j'ai besoin d'aide pour choisir ma taille."], ["📦", "Où est ma commande ?", "Suivi en temps réel", "Bonjour, je voudrais suivre ma commande."], ["↩️", "Retour ou échange", "Portail en 6 étapes", "Bonjour, je voudrais initier un retour ou un échange."], ["🎟️", "Code promo", "Première commande", "Avez-vous un code promo de bienvenue ?"]], cta_title: "Démarrer la conversation", cta_sub: "Réponse en moins de 30 secondes" },
    de: { qr: [["📏", "Welche Größe für mich ?", "Größenberatung in 30 Sek.", "Hallo, ich brauche Hilfe bei der Größenwahl."], ["📦", "Wo ist meine Bestellung ?", "Sendungsverfolgung in Echtzeit", "Hallo, ich möchte meine Bestellung verfolgen."], ["↩️", "Rückgabe oder Umtausch", "Portal in 6 Schritten", "Hallo, ich möchte eine Rückgabe oder einen Umtausch starten."], ["🎟️", "Rabattcode", "Erste Bestellung", "Haben Sie einen Willkommens-Rabattcode ?"]], cta_title: "Gespräch starten", cta_sub: "Antwort in unter 30 Sekunden" },
    it: { qr: [["📏", "Quale taglia per me ?", "Consiglio taglia in 30 sec.", "Salve, ho bisogno di aiuto per scegliere la taglia."], ["📦", "Dov'è il mio ordine ?", "Tracciamento in tempo reale", "Salve, vorrei tracciare il mio ordine."], ["↩️", "Reso o cambio", "Portale in 6 passaggi", "Salve, vorrei avviare un reso o un cambio."], ["🎟️", "Codice sconto", "Primo ordine", "Avete un codice sconto di benvenuto ?"]], cta_title: "Inizia la conversazione", cta_sub: "Risposta in meno di 30 secondi" },
    es: { qr: [["📏", "¿Qué talla es la mía ?", "Consejo de talla en 30 seg.", "Hola, necesito ayuda para elegir mi talla."], ["📦", "¿Dónde está mi pedido ?", "Seguimiento en tiempo real", "Hola, quisiera seguir mi pedido."], ["↩️", "Devolución o cambio", "Portal en 6 pasos", "Hola, quisiera iniciar una devolución o un cambio."], ["🎟️", "Código promo", "Primer pedido", "¿Tienen un código de bienvenida ?"]], cta_title: "Iniciar la conversación", cta_sub: "Respuesta en menos de 30 segundos" },
    nl: { qr: [["📏", "Welke maat voor mij ?", "Maatadvies in 30 sec.", "Hallo, ik heb hulp nodig bij het kiezen van mijn maat."], ["📦", "Waar is mijn bestelling ?", "Realtime tracking", "Hallo, ik wil mijn bestelling volgen."], ["↩️", "Retour of ruil", "Portaal in 6 stappen", "Hallo, ik wil een retour of ruil starten."], ["🎟️", "Kortingscode", "Eerste bestelling", "Heeft u een welkomstkortingscode ?"]], cta_title: "Start het gesprek", cta_sub: "Antwoord binnen 30 seconden" },
    en: { qr: [["📏", "What's my size ?", "Sizing advice in 30 sec.", "Hi, I need help choosing my size."], ["📦", "Where is my order ?", "Real-time tracking", "Hi, I'd like to track my order."], ["↩️", "Return or exchange", "Portal in 6 steps", "Hi, I'd like to start a return or exchange."], ["🎟️", "Promo code", "First order", "Do you have a welcome promo code ?"]], cta_title: "Start the conversation", cta_sub: "Reply in under 30 seconds" }
  };
  function uiQR() {
    var m = UI_QR[_wlang()] || UI_QR.en;
    return m.qr.map(function (q) { return { icon: q[0], title: q[1], sub: q[2], prompt: q[3] }; });
  }
  function uiCTA(key) {
    var m = UI_QR[_wlang()] || UI_QR.en;
    return m[key] || UI_QR.en[key];
  }

  // ====== Config (overridable via window.LS_CHAT_CONFIG) ======
  var CFG = Object.assign(
    {
      apiBase: "https://chat.la-salopette.fr", // backend VPS Infomaniak dedie 24/7 (migration hors Mac 2026-07-21). Ancien bridge Mac ts.net:8443 garde en rollback.
      locale: DETECTED_LOCALE,
      market: DETECTED_MARKET,
      brandShort: BRAND_SHORT,
      brandFull: BRAND_FULL,
      greetingTitle: GR.title,
      greetingSub: GR.sub,
      // Avatars : Juliette = chat live · Louise = SAV email · Ben = atelier.
      // Pour mettre des vraies photos, set `photo` a une URL (le fond se remplit avec l'image).
      // Tu peux uploader les photos dans static/avatars/ et pointer ici.
      // Avatars + emploi du temps mensuel (FR timezone)
      // Horaires "live chat" : ce que le visiteur voit = qui peut répondre direct si humain takeover demandé
      avatars: [
        {
          label: "J", name: "Juliette", role: uiL("role_chat"),
          photo: "/static/avatars/Juliette-la-salopette.jpg",
          photoFallback: "/static/avatars/juliette.svg",
          schedule: uiL("sched_j"),
          online: true
        },
        {
          label: "L", name: "Louise", role: uiL("role_sav"),
          photo: "/static/avatars/Louise-la-salopette.jpg",
          photoFallback: "/static/avatars/louise.svg",
          schedule: uiL("sched_l"),
          online: false
        },
        {
          label: "B", name: "Ben", role: uiL("role_atelier"),
          photo: "/static/avatars/Ben-la-salopette.jpg",
          photoFallback: "/static/avatars/ben.svg",
          schedule: uiL("sched_b"),
          online: false
        }
      ],
      teamLine: uiL("team"),
      teamSubline: "",
      quickReplies: uiQR(),
      featuredCTA: {
        title: uiCTA("cta_title"),
        sub: uiCTA("cta_sub"),
        action: "openChat"
      },
      trust: [
        { label: "Trustpilot 4,2/5", icon: "★", className: "ls-trust-tp" },
        { label: uiL("role_atelier"), icon: "🇫🇷", className: "" },
        { label: uiL("rever_badge"), icon: "↩", className: "" }
      ],
      footerLine: ("<a href='/policies/privacy-policy' target='_blank' rel='noopener'>" +
        ({ de: "Datenschutz", pl: "Polityka prywatności", it: "Privacy", es: "Privacidad",
           nl: "Privacybeleid", en: "Privacy Policy" }[_wlang()] || "Confidentialité") +
        "</a> · LA SALOPETTE OÜ")
    },
    window.LS_CHAT_CONFIG || {}
  );

  // ====== Cookie consent guard ======
  // Respect Pandectes (or any global) consent flag if present.
  function consentGranted() {
    try {
      // Pandectes : window.Pandectes && window.Pandectes.consent
      if (window.Pandectes && typeof window.Pandectes.consent === "function") {
        var c = window.Pandectes.consent();
        return c && (c.functional || c.necessary);
      }
      // Cookiebot : window.Cookiebot.consent
      if (window.Cookiebot && window.Cookiebot.consent) {
        return !!window.Cookiebot.consent.necessary;
      }
      // No consent manager : assume ok (chat is necessary for support)
      return true;
    } catch (e) {
      return true;
    }
  }

  // ====== State ======
  var state = {
    open: false,
    view: "home", // "home" | "chat"
    sessionId: null,
    messages: [],
    sending: false,
    customerEmail: null,
    pendingProactive: null, // texte bulle proactive en attente d'injection dans le chat
    assignedAgent: null,    // index agent attribué à la conv (0=Juliette,1=Louise,2=Ben)
    pendingImage: null      // data URL d'une image jointe en attente d'envoi
  };

  var SESSION_KEY = "lsChat.sessionId.v1";
  var MSGS_KEY = "lsChat.msgs.v1";

  function persistSession() {
    try {
      localStorage.setItem(SESSION_KEY, state.sessionId || "");
      // On NE persiste PAS les images base64 (bloat localStorage) : on garde role+content only.
      localStorage.setItem(MSGS_KEY, JSON.stringify(state.messages.slice(-40).map(function (m) {
        return { role: m.role, content: m.content };
      })));
    } catch (e) {}
  }
  function loadSession() {
    try {
      state.sessionId = localStorage.getItem(SESSION_KEY) || null;
      var raw = localStorage.getItem(MSGS_KEY);
      if (raw) state.messages = JSON.parse(raw) || [];
    } catch (e) {}
  }

  // ====== SVG icons ======
  var ICONS = {
    chat: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    send: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    home: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2h-4v-7H10v7H6a2 2 0 0 1-2-2V9z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    msg: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    clip: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  // ====== DOM build ======
  function el(tag, attrs, children) {
    var e = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (k === "class") e.className = attrs[k];
      else if (k === "html") e.innerHTML = attrs[k];
      else if (k.indexOf("on") === 0 && typeof attrs[k] === "function") e.addEventListener(k.slice(2), attrs[k]);
      else e.setAttribute(k, attrs[k]);
    }
    if (children) (Array.isArray(children) ? children : [children]).forEach(function (c) {
      if (c == null) return;
      if (typeof c === "string") e.appendChild(document.createTextNode(c));
      else e.appendChild(c);
    });
    return e;
  }

  function renderRoot() {
    var root = el("div", { id: "ls-chat-root" });
    // Labels du drawer "équipe" localisés (CSS ::after via variables)
    try {
      root.style.setProperty("--ls-label-collapse", '"' + uiL("collapse") + '"');
      root.style.setProperty("--ls-label-hours", '"' + uiL("see_hours") + '"');
    } catch (e) {}
    root.appendChild(renderFab());
    root.appendChild(renderPanel());
    return root;
  }

  function renderFab() {
    var fab = el("button", {
      class: "ls-fab attention",
      "aria-label": "Ouvrir le chat",
      onclick: toggleOpen,
      html: ICONS.chat
    });
    // Halo glow extérieur (orbe aura)
    fab.insertBefore(el("span", { class: "ls-fab-glow", "aria-hidden": "true" }, ""), fab.firstChild);
    fab.appendChild(el("span", { class: "ls-fab-badge", id: "ls-fab-badge" }, ""));
    return fab;
  }

  function renderPanel() {
    var panel = el("div", { class: "ls-panel", id: "ls-panel" });

    // Header (sans la marque "LS / La Salopette" : Arnaud 2026-05-30 "ca sert a rien").
    // On garde une barre top juste pour le bouton fermer, aligne a droite.
    var header = el("div", { class: "ls-header" });
    var top = el("div", { class: "ls-header-top ls-header-top--nobrand" });
    var closeBtn = el("button", { class: "ls-close", "aria-label": "Fermer", type: "button", onclick: function (e) { e.preventDefault(); e.stopPropagation(); toggleOpen(); }, html: ICONS.close });
    // Defensive : aussi sur touchend pour iOS Safari edge cases
    closeBtn.addEventListener("touchend", function (e) { e.preventDefault(); e.stopPropagation(); toggleOpen(); }, { passive: false });
    top.appendChild(closeBtn);
    header.appendChild(top);

    var greet = el("div", { class: "ls-greeting" }, [
      el("h2", null, CFG.greetingTitle),
      el("p", null, CFG.greetingSub)
    ]);
    header.appendChild(greet);
    // ⏱️ Info dynamique (comble le vide du header) : date du jour + heure + fuseau du CLIENT, dans sa
    // langue. Maj chaque minute. new Date()/Intl = cote client (OK ici, pas mon env). Arnaud 2026-06-25.
    var nowEl = el("div", { class: "ls-now", id: "ls-now" }, "");
    header.appendChild(nowEl);
    (function () {
      var LOC = { fr: "fr-FR", de: "de-DE", it: "it-IT", es: "es-ES", nl: "nl-NL", en: "en-GB" , pl: "pl-PL" };
      function updateNow() {
        var e = document.getElementById("ls-now"); if (!e) return;
        try {
          var d = new Date(), loc = LOC[_wlang()] || "en-GB";
          var date = d.toLocaleDateString(loc, { weekday: "long", day: "numeric", month: "long" });
          var time = d.toLocaleTimeString(loc, { hour: "2-digit", minute: "2-digit" });
          var tz = "";
          try { var pr = new Intl.DateTimeFormat(loc, { timeZoneName: "short" }).formatToParts(d); for (var i = 0; i < pr.length; i++) if (pr[i].type === "timeZoneName") tz = pr[i].value; } catch (e2) {}
          e.textContent = "📅 " + date + " · 🕐 " + time + (tz ? " · " + tz : "");
        } catch (e3) {}
      }
      updateNow();
      try { clearInterval(window._lsNowIv); } catch (e) {}
      window._lsNowIv = setInterval(updateNow, 60000);
    })();

    // ===== Avatar stack avec LISERÉ COLOR online/offline + CLICK EXPAND =====
    // Calcul online dynamique avec rotation réaliste : parfois 1, parfois 2, parfois 3 agents en ligne
    // Déterministe par heure (stable pour un visiteur dans la même heure) mais varié sur la journée
    function _hash(s) {
      var h = 5381;
      for (var i = 0; i < s.length; i++) h = ((h << 5) + h) ^ s.charCodeAt(i);
      return Math.abs(h) % 100;
    }
    function _inWindow(h, start, end) {
      // gère windows qui passent minuit (start > end)
      return start <= end ? (h >= start && h < end) : (h >= start || h < end);
    }
    function computeOnline(agent) {
      var now = new Date();
      var h = now.getHours();
      var day = now.getDay(); // 0 = Sunday, 6 = Saturday
      var name = agent.name;
      // Base schedule (capable d'être en ligne)
      var base = false, edge = false;
      if (name === "Juliette") {
        // Lun-Ven 8h-22h core, edge 6h-8h + 22h-24h ; Sam 10h-19h core
        if (day >= 1 && day <= 5) { base = _inWindow(h, 8, 22); edge = _inWindow(h, 6, 8) || _inWindow(h, 22, 24); }
        else if (day === 6)        { base = _inWindow(h, 10, 19); edge = _inWindow(h, 8, 10) || _inWindow(h, 19, 22); }
        else                       { edge = _inWindow(h, 11, 18); } // dimanche cameo
      } else if (name === "Louise") {
        // Lun-Ven 10h-14h core (Arnaud 2026-07-13 : Louise moins d'heures), edge 9h-10h + 14h-16h, Sam matin cameo
        if (day >= 1 && day <= 5) { base = _inWindow(h, 10, 14); edge = _inWindow(h, 9, 10) || _inWindow(h, 14, 16); }
        else if (day === 6)        { edge = _inWindow(h, 10, 13); }
        else                       { edge = false; }
      } else if (name === "Ben") {
        // Lun-Sam 7h-16h core (Arnaud 2026-07-13 : Ben convertit mieux -> plus d'heures), edge 16h-18h + 6h-7h
        if (day >= 1 && day <= 6) { base = _inWindow(h, 7, 16); edge = _inWindow(h, 16, 18) || _inWindow(h, 6, 7); }
        else                       { edge = _inWindow(h, 9, 12); } // dimanche atelier perso
      }
      // Présence variée déterministe : hash(nom + jour*24+heure)
      var roll = _hash(name + ":" + (day * 24 + h));
      // Thresholds : roll < threshold = online · base=75% / edge=35% / off=8%
      var threshold = base ? 75 : (edge ? 35 : 8);
      return roll < threshold;
    }
    // Garantie : si computeOnline retourne 0 agent en ligne, force au moins le rotatif du jour
    function ensureAtLeastOneOnline(agents) {
      var anyOnline = agents.some(function (a) { return a.online; });
      if (!anyOnline) {
        var now = new Date();
        var rotIdx = (now.getDay() * 7 + now.getHours()) % agents.length;
        agents[rotIdx].online = true;
      }
    }

    var avs = el("div", { class: "ls-avatars", id: "ls-avatars" });
    avs.setAttribute("title", uiL("see_online"));

    // Pré-calcul online pour tous les agents + garantir min 1 en ligne
    CFG.avatars.forEach(function (a) { a.online = computeOnline(a); });
    ensureAtLeastOneOnline(CFG.avatars);

    CFG.avatars.forEach(function (a, i) {
      var photoUrl = a.photo;
      if (photoUrl && photoUrl.charAt(0) === "/") {
        photoUrl = CFG.apiBase + photoUrl;
      }
      var avAttrs = {
        class: "ls-avatar " + (a.online ? "is-online" : "is-offline"),
        title: a.name + " - " + a.role + " (" + (a.online ? uiL("online_s") : uiL("offline_s")) + ")",
      };
      if (photoUrl) {
        avAttrs.style = "background-image:url('" + photoUrl + "');background-size:cover;background-position:center;color:transparent";
      }
      var av = el("div", avAttrs, photoUrl ? "" : a.label);
      // Defensive : if photo 404, fallback to SVG then to initial label
      if (photoUrl) {
        (function (imgUrl, node, label, fallbackUrl) {
          var img = new Image();
          img.onerror = function () {
            // Try fallback SVG
            if (fallbackUrl) {
              var fb = fallbackUrl.charAt(0) === "/" ? CFG.apiBase + fallbackUrl : fallbackUrl;
              var img2 = new Image();
              img2.onerror = function () {
                node.style.backgroundImage = "";
                node.style.color = "";
                node.textContent = label;
              };
              img2.onload = function () {
                node.style.backgroundImage = "url('" + fb + "')";
              };
              img2.src = fb;
            } else {
              node.style.backgroundImage = "";
              node.style.color = "";
              node.textContent = label;
            }
          };
          img.src = imgUrl;
        })(photoUrl, av, a.label, a.photoFallback);
      }

      // Wrap dans .ls-agent-row (pour mode expanded) + data-idx pour attribution
      var agentRow = el("div", { class: "ls-agent-row", "data-agent-idx": String(i) }, []);
      agentRow.appendChild(av);
      // Card horaires (visible en mode expanded)
      var statusDot = a.online ? '<span class="dot green"></span>' + uiL("online") : '<span class="dot red"></span>' + uiL("offline");
      var card = el("div", {
        class: "ls-agent-card",
        html: '<span class="name">' + a.name + '</span>' +
              '<span class="role" style="opacity:.75;font-size:11px">' + a.role + '</span>' +
              '<div class="status">' + statusDot + '</div>' +
              '<div class="hours">📅 ' + a.schedule + '</div>' +
              '<div class="quote">' + pickQuote(a.name) + '</div>'
      });
      agentRow.appendChild(card);
      avs.appendChild(agentRow);
    });

    // Meta line (visible quand collapsed)
    avs.appendChild(el("div", {
      class: "ls-avatars-meta",
      html: "<strong>" + CFG.teamLine + "</strong><span class='hint'>👆 " + uiL("hint_hours") + "</span>"
    }));

    // Handle drawer TOUJOURS visible (collapse/expand clair) : chevron + label
    var handle = el("div", {
      class: "ls-drawer-handle",
      html: "<span class='ls-drawer-chevron'>⌄</span><span class='ls-drawer-label'></span>"
    });
    avs.appendChild(handle);

    // Toggle helper (chevron rotation + label swap géré en CSS via .expanded)
    function toggleDrawer(e) {
      if (e) e.stopPropagation();
      avs.classList.toggle("expanded");
    }
    // Click sur les avatars (collapsed) OU sur le handle = toggle
    avs.addEventListener("click", function (e) {
      // Clic sur une carte agent (rectangle) → ouvre/reprend la conv avec cet agent
      var card = e.target.closest(".ls-agent-card");
      var row = e.target.closest(".ls-agent-row");
      if (card && row) {
        e.stopPropagation();
        var idx = parseInt(row.getAttribute("data-agent-idx"), 10);
        openChatWithAgent(idx);
        return;
      }
      toggleDrawer(e);
    });

    header.appendChild(avs);
    panel.appendChild(header);

    // Body
    var body = el("div", { class: "ls-body" });

    // -- Home view --
    var home = el("div", { class: "ls-view active", id: "ls-home" });
    var cta = el("button", { class: "ls-card ls-card-cta", onclick: function () { goView("chat"); focusInput(); } }, [
      el("div", { class: "ls-card-icon", html: ICONS.chat }),
      el("div", { class: "ls-card-body", html: "<strong>" + CFG.featuredCTA.title + "</strong><span>" + CFG.featuredCTA.sub + "</span>" }),
      el("div", { class: "ls-card-arrow", html: "→" })
    ]);
    var cards = el("div", { class: "ls-home-cards" });
    cards.appendChild(cta);
    CFG.quickReplies.forEach(function (q) {
      var c = el("button", { class: "ls-card", onclick: function () { sendVisitorMessage(q.prompt); } }, [
        el("div", { class: "ls-card-icon" }, q.icon),
        el("div", { class: "ls-card-body", html: "<strong>" + q.title + "</strong><span>" + q.sub + "</span>" }),
        el("div", { class: "ls-card-arrow", html: "→" })
      ]);
      cards.appendChild(c);
    });
    home.appendChild(cards);

    // Trust
    var trust = el("div", { class: "ls-trust" });
    CFG.trust.forEach(function (t) {
      trust.appendChild(el("span", { class: "ls-trust-item " + (t.className || "") },
        [el("span", { class: "star" }, t.icon), document.createTextNode(" " + t.label)]));
    });
    home.appendChild(trust);
    body.appendChild(home);

    // -- Chat view --
    var chat = el("div", { class: "ls-view", id: "ls-chat" });
    var thread = el("div", { class: "ls-thread", id: "ls-thread" });
    chat.appendChild(thread);
    body.appendChild(chat);

    panel.appendChild(body);

    // Tabs
    var tabs = el("div", { class: "ls-tabs" });
    tabs.appendChild(el("button", { class: "ls-tab active", id: "ls-tab-home", onclick: function () { collapseAvatars(); goView("home"); }, html: ICONS.home + "<span>" + uiL("tab_home") + "</span>" }));
    tabs.appendChild(el("button", { class: "ls-tab", id: "ls-tab-chat", onclick: function () { collapseAvatars(); goView("chat"); }, html: ICONS.msg + "<span>" + uiL("tab_chat") + "</span>" }));
    panel.appendChild(tabs);

    // Apercu image jointe (au-dessus de la barre de saisie)
    panel.appendChild(el("div", { class: "ls-img-preview", id: "ls-img-preview", style: "display:none" }));

    // Input bar (only on chat view, but we render once)
    var inputBar = el("div", { class: "ls-input-bar", id: "ls-input-bar", style: "display:none" });
    var fileInput = el("input", { type: "file", accept: "image/*", id: "ls-file", style: "display:none" });
    fileInput.addEventListener("change", function () { if (this.files && this.files[0]) handleImageFile(this.files[0]); this.value = ""; });
    var clipBtn = el("button", { class: "ls-clip", id: "ls-clip", "aria-label": uiL("attach"), title: uiL("attach"), onclick: function () { fileInput.click(); }, html: ICONS.clip });
    var input = el("textarea", { class: "ls-input", id: "ls-input", placeholder: uiL("input_ph"), rows: "1" });
    input.addEventListener("input", function () { autoResize(); _emitVisitorTyping(this.value); });
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendFromInput(); }
    });
    input.addEventListener("paste", function (e) {
      var items = (e.clipboardData && e.clipboardData.items) || [];
      for (var i = 0; i < items.length; i++) {
        if (items[i].type && items[i].type.indexOf("image/") === 0) { var f = items[i].getAsFile(); if (f) { handleImageFile(f); e.preventDefault(); } }
      }
    });
    var sendBtn = el("button", { class: "ls-send", id: "ls-send", "aria-label": "Envoyer", onclick: sendFromInput, html: ICONS.send });
    inputBar.appendChild(clipBtn);
    inputBar.appendChild(input);
    inputBar.appendChild(sendBtn);
    inputBar.appendChild(fileInput);
    panel.appendChild(inputBar);

    // Glisser-deposer une image directement dans le chat
    panel.addEventListener("dragover", function (e) {
      if (e.dataTransfer && Array.prototype.indexOf.call(e.dataTransfer.types || [], "Files") !== -1) { e.preventDefault(); panel.classList.add("ls-dragover"); }
    });
    panel.addEventListener("dragleave", function (e) { if (e.target === panel) panel.classList.remove("ls-dragover"); });
    panel.addEventListener("drop", function (e) {
      if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
        var f = e.dataTransfer.files[0];
        if (f && (f.type || "").indexOf("image/") === 0) { e.preventDefault(); panel.classList.remove("ls-dragover"); goView("chat"); handleImageFile(f); }
      }
    });

    // Footer
    panel.appendChild(el("div", { class: "ls-footer-meta", html: CFG.footerLine }));

    return panel;
  }

  // 🔴 LIVE typing -> Louise voit le brouillon du visiteur AVANT l'envoi (Tidio-like). Throttle 600ms.
  var _vtT = null, _vtPending = false;
  function _emitVisitorTyping() {
    _vtPending = true;
    if (_vtT) return;
    _vtT = setTimeout(function () {
      _vtT = null;
      if (!_vtPending) return;
      _vtPending = false;
      try {
        var cur = ((document.getElementById("ls-input") || {}).value || "").slice(0, 240);
        fetch(CFG.apiBase + "/api/chat/session/" + state.sessionId + "/typing-visitor", {
          method: "POST", headers: { "Content-Type": "text/plain;charset=UTF-8" },
          body: JSON.stringify({ text: cur }), keepalive: true
        }).catch(function () {});
      } catch (e) {}
    }, 600);
  }
  function autoResize() {
    var t = document.getElementById("ls-input");
    if (!t) return;
    t.style.height = "auto";
    t.style.height = Math.min(t.scrollHeight, 110) + "px";
  }

  // ====== Behaviors ======
  function toggleOpen() {
    state.open = !state.open;
    var panel = document.getElementById("ls-panel");
    var fab = document.getElementById("ls-fab");
    if (!panel) return;
    var _root = document.getElementById("ls-chat-root");
    if (state.open) {
      panel.classList.add("open");
      if (_root) _root.classList.add("ls-root-open"); // retire le transform du root (sinon panel decentre, fallback robuste vs :has)
      if (fab) { fab.style.opacity = "0"; fab.style.visibility = "hidden"; fab.style.pointerEvents = "none"; fab.style.transform = "translateZ(0) scale(.6)"; }
      hideBadge();
      collapseAvatars();
      lsBeacon("chat"); // tracking : a ouvert le chat (engage)
      reEnable(); // active la re-engagement (5 min inactivite / depart) une fois le chat ouvert
      // Si une bulle proactive est en attente → l'injecter comme message bot dans le chat
      var consumed = consumeProactive();
      if (consumed || state.messages.length) goView("chat");
      else goView("home");
    } else {
      panel.classList.remove("open");
      if (_root) _root.classList.remove("ls-root-open");
      if (fab) { fab.style.opacity = ""; fab.style.visibility = ""; fab.style.pointerEvents = ""; fab.style.transform = ""; }
      collapseAvatars();
      // tracking : "close" s'il n'a jamais ecrit (ouvert juste pour fermer), sinon "chat" (engage)
      var _wrote = state.messages.some(function (m) { return m.role === "user"; });
      lsBeacon(_wrote ? "chat" : "close");
      // 🚪 Signal FERMETURE cote backend (Arnaud 2026-08-04 : "indique-moi quand le client a ferme
      // la conv, cote backend"). Beacon leger, ne bloque rien, ignore si pas de session ouverte.
      try {
        if (_wrote && state.sessionId) {
          var _cb = JSON.stringify({ session_id: state.sessionId });
          if (navigator.sendBeacon) {
            navigator.sendBeacon(CFG.apiBase + "/api/chat/closed",
              new Blob([_cb], { type: "text/plain;charset=UTF-8" }));
          } else {
            fetch(CFG.apiBase + "/api/chat/closed", { method: "POST", keepalive: true,
              headers: { "Content-Type": "text/plain;charset=UTF-8" }, body: _cb });
          }
        }
      } catch (e) {}
    }
  }

  // ===== Tracking visiteur (Bloc 3) : beacon page + interaction chat =====
  function lsVisitorId() {
    var k = "ls_visitor_id", v = "";
    try { v = localStorage.getItem(k) || ""; } catch (e) {}
    if (!v) {
      v = "v_" + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
      try { localStorage.setItem(k, v); } catch (e) {}
    }
    return v;
  }
  // Shopify clientId (cookie _shopify_y) : MEME valeur cote storefront ET cote checkout (Web Pixel).
  // Sert de cle de correlation pour relier le parcours navigation au checkout/achat vu par le Web Pixel
  // (Arnaud 2026-06-13 : Louise aveugle sur le paiement/achat, le pixel comble ce trou).
  function lsShopifyCid() {
    try { var m = (document.cookie || "").match(/(?:^|;\s*)_shopify_y=([^;]+)/); return m ? decodeURIComponent(m[1]) : ""; }
    catch (e) { return ""; }
  }
  // ===== Etape funnel (Arnaud 2026-06-04) : ROUGE = panier actif/drawer/page panier · NOIR = checkout =====
  var _lsCartCount = 0;
  var _lsCart = null;  // {count,total,currency,items:[{title,qty,price}]} pour la fiche visiteur Louise
  function lsRefreshCart(reBeacon) {
    try {
      fetch((CFG.apiBase ? "" : "") + "/cart.js", { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var _prevCount = _lsCartCount;
          _lsCartCount = (c && c.item_count) || 0;
          // Re-beacon DES que /cart.js confirme un panier (au lieu de dependre du timeout 400ms aveugle
          // au chargement) -> le rouge "panier" est fiable a 100%, plus de race condition. Arnaud 2026-06-13.
          if (reBeacon && _lsCartCount > 0 && _prevCount === 0) {
            try { lsBeacon("none"); } catch (e) {}
          }
          if (c && c.item_count) {
            // Shopify /cart.js = prix en centimes (minor units) -> /100 pour la devise
            _lsCart = {
              count: c.item_count,
              total: Math.round(c.total_price || 0) / 100,
              currency: c.currency || "",
              items: (c.items || []).slice(0, 12).map(function (it) {
                var vt = String(it.variant_title || "").trim();
                if (/^default title$/i.test(vt)) vt = "";       // variante par defaut = pas de taille a montrer
                return {
                  title: String(it.product_title || it.title || "").slice(0, 80),
                  variant: vt.slice(0, 40),                       // taille / variante choisie (S,M,L... ou "Bleu / L")
                  qty: it.quantity || 1,
                  price: Math.round(it.final_line_price || it.line_price || 0) / 100
                };
              })
            };
          } else { _lsCart = null; }
        })
        .catch(function () {});
    } catch (e) {}
  }
  function lsFunnelStage() {
    try {
      var p = (location.pathname || "").toLowerCase();
      if (/\/(checkout|thank|orders)\b/.test(p) || /(^|\.)checkout\./.test(location.hostname)) return "checkout";
      if (/\/cart(\/|$|\?)/.test(p)) return "cart";
      if (typeof lsCartDrawerOpen === "function" && lsCartDrawerOpen()) return "cart";
      if (_lsCartCount > 0) return "cart";  // panier actif meme en navigant
      return "none";
    } catch (e) { return "none"; }
  }
  function lsBeacon(interaction, stageOverride) {
    try {
      var body = JSON.stringify({
        visitor_id: lsVisitorId(),
        url: location.href.slice(0, 300),
        ref: (document.referrer || "").slice(0, 200),  // 🚦 source de trafic : SEO vs Direct (Arnaud 2026-06-10)
        title: (document.title || "").slice(0, 120),
        market: (CFG && CFG.market) || detectLocale(),
        locale: detectLocale(),
        interaction: interaction || "none",
        stage: stageOverride || lsFunnelStage(),
        cid: lsShopifyCid() || undefined,  // cle de correlation avec le Web Pixel (checkout/achat)
        cart: _lsCart || undefined  // panier visiteur (produits + montant) -> fiche Louise
      });
      var u = CFG.apiBase + "/api/track/visit";
      // 🚨 text/plain = requete CORS SIMPLE (pas de preflight OPTIONS) -> le POST passe direct dans
      // tous les navigateurs. application/json declenchait un preflight qui faisait dropper le POST
      // (Safari) -> 0.06% de capture vs GA4. Le serveur lit le body brut + json.loads. Arnaud 2026-06-02.
      if (navigator.sendBeacon) {
        var okb = navigator.sendBeacon(u, new Blob([body], { type: "text/plain;charset=UTF-8" }));
        if (!okb) { fetch(u, { method: "POST", headers: { "Content-Type": "text/plain;charset=UTF-8" }, body: body, keepalive: true }).catch(function () {}); }
      } else {
        fetch(u, { method: "POST", headers: { "Content-Type": "text/plain;charset=UTF-8" }, body: body, keepalive: true }).catch(function () {});
      }
    } catch (e) {}
  }

  // openChat = ouvre le panel si fermé (utilisé par bulle proactive + API)
  function openChat() {
    if (!state.open) toggleOpen();
  }

  // ===== ATTRIBUTION AGENT =====
  // Choisit l'agent qui prend la conv : prefere l'agent demande s'il est EN LIGNE,
  // sinon priorite Ben > Juliette > Louise (Arnaud 2026-07-13 : Ben convertit mieux), sinon le rotatif garanti.
  function assignAgent(preferIdx) {
    var ags = CFG.avatars || [];
    // Lit le statut .online déjà calculé au render (NE PAS appeler computeOnline ici : closure interne).
    var anyOnline = ags.some(function (a) { return a.online; });
    if (!anyOnline && ags.length) {
      // Filet : force le rotatif du jour en ligne
      var now = new Date();
      ags[(now.getDay() * 7 + now.getHours()) % ags.length].online = true;
    }
    var idx = -1;
    if (typeof preferIdx === "number" && ags[preferIdx] && ags[preferIdx].online) {
      idx = preferIdx; // l'agent cliqué est en ligne → c'est lui
    } else {
      var prio = [2, 0, 1]; // Ben (2) > Juliette (0) > Louise (1)
      for (var pi = 0; pi < prio.length; pi++) { var ii = prio[pi]; if (ags[ii] && ags[ii].online) { idx = ii; break; } }
      if (idx < 0) { for (var i = 0; i < ags.length; i++) { if (ags[i].online) { idx = i; break; } } }
    }
    if (idx < 0) idx = 0;
    state.assignedAgent = idx;
    return idx;
  }

  // Applique le visuel d'attribution : agent assigne grossit, les autres retrecissent (smooth)
  function applyAssignmentVisual() {
    var avs = document.getElementById("ls-avatars");
    if (!avs) return;
    if (typeof state.assignedAgent !== "number") { avs.classList.remove("has-assignment"); return; }
    avs.classList.add("has-assignment");
    avs.classList.remove("expanded"); // replie le drawer pendant la conv
    var rows = avs.querySelectorAll(".ls-agent-row");
    Array.prototype.forEach.call(rows, function (row) {
      var idx = parseInt(row.getAttribute("data-agent-idx"), 10);
      row.classList.toggle("is-assigned", idx === state.assignedAgent);
    });
    // Met a jour la meta line : prenom + role · statut (sans "te repond")
    var meta = avs.querySelector(".ls-avatars-meta");
    if (meta && CFG.avatars[state.assignedAgent]) {
      var ag = CFG.avatars[state.assignedAgent];
      var statusTxt = ag.online ? uiL("online_s") : uiL("offline_s");
      meta.innerHTML = "<strong>" + ag.name + "</strong><span>" + ag.role + " · " + statusTxt + (ag.online ? " 🟢" : "") + "</span>";
    }
  }

  // Clic sur un agent (rectangle) → ouvre/reprend la conv, attribue l'agent (online sinon fallback online)
  function openChatWithAgent(preferIdx) {
    assignAgent(preferIdx);
    openChat();           // ouvre le panel si ferme
    goView("chat");       // reprend la conv (renderThread restaure les messages existants)
    applyAssignmentVisual();
    focusInput();
  }

  // Injecte la bulle proactive en attente comme 1er message bot dans le thread, puis la retire
  function consumeProactive() {
    var bubble = document.getElementById("ls-proactive-bubble");
    if (state.pendingProactive) {
      // Évite doublon si déjà présent comme dernier message
      var last = state.messages[state.messages.length - 1];
      if (!last || last.content !== state.pendingProactive) {
        state.messages.push({ role: "assistant", content: state.pendingProactive });
        persistSession();
      }
      state.pendingProactive = null;
      if (bubble) bubble.remove();
      renderThread();
      return true;
    }
    if (bubble) bubble.remove();
    return false;
  }

  function collapseAvatars() {
    var avs = document.getElementById("ls-avatars");
    if (avs) avs.classList.remove("expanded");
  }

  function goView(view) {
    state.view = view;
    document.getElementById("ls-home").classList.toggle("active", view === "home");
    document.getElementById("ls-chat").classList.toggle("active", view === "chat");
    document.getElementById("ls-tab-home").classList.toggle("active", view === "home");
    document.getElementById("ls-tab-chat").classList.toggle("active", view === "chat");
    document.getElementById("ls-input-bar").style.display = view === "chat" ? "flex" : "none";
    // En vue CHAT : replie le gros header (greeting "Hey 👋" + sous-titre + avatars) pour donner
    // le MAX d'espace a la conversation (Arnaud 2026-05-30 "l'espace pour le chat est trop petit,
    // enleve le haut"). Le header reste complet en vue Accueil.
    var panel = document.getElementById("ls-panel");
    if (panel) panel.classList.toggle("ls-chat-mode", view === "chat");
    if (view === "chat") {
      // Attribue un agent (online prioritaire) si pas deja fait, puis applique le visuel smooth
      if (typeof state.assignedAgent !== "number") assignAgent();
      applyAssignmentVisual();
      renderThread();
      focusInput();
    } else {
      // Retour accueil : retire l'attribution visuelle
      var avs = document.getElementById("ls-avatars");
      if (avs) avs.classList.remove("has-assignment");
    }
  }

  function focusInput() {
    setTimeout(function () {
      var i = document.getElementById("ls-input");
      if (i) i.focus();
    }, 200);
  }

  function renderThread() {
    var t = document.getElementById("ls-thread");
    if (!t) return;
    t.innerHTML = "";
    if (state.messages.length === 0) {
      // First entry into chat : accueil CHALEUREUX et HUMAIN, varie a chaque session (Arnaud 2026-06-01
      // "reste humain au maximum"). Pas de menu a puces froid : les chips ci-dessous couvrent deja les sujets.
      // Sans prenom, sans marque (multi-market), vouvoiement.
      var _greets = [
        "Bonjour 👋 Bienvenue à l'atelier. Dites-moi ce qui vous amène, je suis là pour vous aider.",
        "Bonjour ☺️ Une question, une envie, une commande à suivre ? Je vous écoute avec plaisir.",
        "Bonjour 👖 Bienvenue ! Sur quoi puis-je vous aider aujourd'hui ?",
        "Bonjour ! Dites-moi tout, je m'en occupe avec plaisir.",
        "Bonjour ☺️ Je suis là pour un conseil de taille, le choix d'un modèle ou le suivi de votre commande. Que puis-je faire pour vous ?"
      ];
      var greetText = _greets[Math.floor(Math.random() * _greets.length)];
      var hello = el("div", { class: "ls-msg assistant" }, [
        msgAvatarEl(),
        el("div", { class: "ls-msg-bubble" }, greetText)
      ]);
      t.appendChild(hello);
      var chips = el("div", { class: "ls-chips" });
      CFG.quickReplies.forEach(function (q) {
        chips.appendChild(el("button", {
          class: "ls-chip",
          onclick: function () { sendVisitorMessage(q.prompt); }
        }, q.title));
      });
      t.appendChild(chips);
    } else {
      state.messages.forEach(function (m) { t.appendChild(buildMessageNode(m)); });
    }
    scrollThread();
  }

  // Operateur courant : agent assigne si defini, sinon 1er en ligne, sinon Juliette (avatars[0]).
  function pickOperator() {
    var avs = CFG.avatars || [];
    if (typeof state.assignedAgent === "number" && avs[state.assignedAgent]) return avs[state.assignedAgent];
    for (var i = 0; i < avs.length; i++) { if (avs[i] && avs[i].online) return avs[i]; }
    return avs[0] || { label: "L" };
  }
  // Avatar de message = PHOTO de l'operateur en ligne (Juliette par defaut), pas un "L" generique.
  function msgAvatarEl() {
    var op = pickOperator();
    var photoUrl = op.photo;
    if (photoUrl && photoUrl.charAt(0) === "/") photoUrl = CFG.apiBase + photoUrl;
    var attrs = { class: "ls-msg-avatar" };
    if (photoUrl) attrs.style = "background-image:url('" + photoUrl + "');background-size:cover;background-position:center;color:transparent";
    var node = el("div", attrs, photoUrl ? "" : (op.label || "L"));
    if (photoUrl) {
      (function (imgUrl, n, label, fallbackUrl) {
        var img = new Image();
        img.onerror = function () {
          if (fallbackUrl) {
            var fb = fallbackUrl.charAt(0) === "/" ? CFG.apiBase + fallbackUrl : fallbackUrl;
            var img2 = new Image();
            img2.onerror = function () { n.style.backgroundImage = ""; n.style.color = ""; n.textContent = label; };
            img2.onload = function () { n.style.backgroundImage = "url('" + fb + "')"; };
            img2.src = fb;
          } else { n.style.backgroundImage = ""; n.style.color = ""; n.textContent = label; }
        };
        img.src = imgUrl;
      })(photoUrl, node, op.label || "L", op.photoFallback);
    }
    return node;
  }

  function buildMessageNode(m) {
    var node = el("div", { class: "ls-msg " + (m.role === "user" ? "user" : "assistant") });
    if (m.role === "assistant") node.appendChild(msgAvatarEl());
    var bubble = el("div", { class: "ls-msg-bubble" });
    if (m.image) {
      var im = document.createElement("img");
      im.src = m.image; im.className = "ls-msg-img"; im.alt = "image jointe";
      bubble.appendChild(im);
    }
    if (m.content) {
      var txt = document.createElement("div");
      txt.innerHTML = escapeAndLinkify(m.content);
      bubble.appendChild(txt);
    }
    node.appendChild(bubble);
    return node;
  }

  function escapeAndLinkify(text) {
    var div = document.createElement("div");
    div.textContent = text;
    var safe = div.innerHTML;
    // inline code `x`
    safe = safe.replace(/`([^`\n]+)`/g, "<code>$1</code>");
    // Markdown links [text](url) → <a> (FIRST, avant linkify URL nue, pour pas double-transform)
    // Ponctuation collee en fin de href = lien 404 (Arnaud 2026-07-15, cas nous-contacter,) : on la vire.
    safe = safe.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, function (m, txt, url) {
      var t = url.match(/[,.;:!?'"]+$/); if (t) url = url.slice(0, url.length - t[0].length);
      return '<a href="' + url + '" target="_blank" rel="noopener">' + txt + '</a>';
    });
    // Linkify URL nues restantes (pas dans href existant) : la ponctuation finale reste HORS du lien
    safe = safe.replace(/(^|[^"=])(https?:\/\/[^\s<]+)/g, function (m, pre, url) {
      var t = url.match(/[),.;:!?'"\]]+$/); var trail = t ? t[0] : "";
      if (trail) url = url.slice(0, url.length - trail.length);
      return pre + '<a href="' + url + '" target="_blank" rel="noopener">' + url + '</a>' + trail;
    });
    // Titres ## -> ligne en gras
    safe = safe.replace(/^\s{0,3}#{1,6}\s+(.+?)\s*#*$/gm, "<strong>$1</strong>");
    // Separateur --- *** ___
    safe = safe.replace(/^\s*([-*_]\s*){3,}$/gm, "<hr class='ls-hr'>");
    // Bullets : * item ou - item au début de ligne
    safe = safe.replace(/^\s*[\*\-]\s+(.+)$/gm, "• $1");
    // Gras **x** et __x__
    safe = safe.replace(/\*\*([^*\n]+)\*\*/g, "<strong>$1</strong>");
    safe = safe.replace(/__([^_\n]+)__/g, "<strong>$1</strong>");
    // Italique *x* et _x_
    safe = safe.replace(/(^|[^\*\w])\*([^*\n]+)\*(?!\w)/g, "$1<em>$2</em>");
    safe = safe.replace(/(^|[^_\w])_([^_\n]+)_(?!\w)/g, "$1<em>$2</em>");
    // Newlines → <br> (chat-friendly)
    safe = safe.replace(/\n/g, "<br>");
    return safe;
  }

  function scrollThread() {
    var body = document.querySelector(".ls-body");
    if (body) setTimeout(function () { body.scrollTop = body.scrollHeight; }, 50);
  }

  // Persona active du typing : 0/Juliette (blonde+lunettes), 1/Louise (brune+pull rouge), 2/Ben (bucheron).
  function _typingPersona() {
    try {
      var a = CFG.avatars || [], i = (typeof state.assignedAgent === "number") ? state.assignedAgent : 0;
      var n = ((a[i] && a[i].name) || "").toLowerCase();
      if (n.indexOf("louise") >= 0) return "louise";
      if (n.indexOf("ben") >= 0) return "ben";
      return "juliette";
    } catch (e) { return "juliette"; }
  }
  // Scene de typing animee + persona-aware + decor bureau qui apparait a 3s (Arnaud 2026-06-08).
  function _typingSceneSVG() {
    // Scenes multi-phases (Arnaud 2026-06-10) : Juliette tape -> boit un cafe -> casque + notes ;
    // Louise casque permanent + tete en rythme + boulette -> poubelle ; Ben marche -> coupe -> range -> repart.
    var p = _typingPersona();
    var STYLE = '<style>'
      + '@keyframes lst2Bob{0%,100%{transform:translateY(0) rotate(0)}22%{transform:translateY(-1.6px) rotate(-1.3deg)}48%{transform:translateY(.3px) rotate(.7deg)}72%{transform:translateY(-1px) rotate(1.1deg)}}'
      + '@keyframes lst2TA{0%,100%{transform:translateY(0)}50%{transform:translateY(-2.4px)}}'
      + '@keyframes lst2TB{0%,100%{transform:translateY(-2.4px)}50%{transform:translateY(0)}}'
      + '@keyframes lst2Dot{0%,70%,100%{opacity:.2;transform:translateY(0)}35%{opacity:1;transform:translateY(-2px)}}'
      + '@keyframes lst2In{to{opacity:1}}'
      + '.lst2-bg{opacity:0;animation:lst2In .8s ease 3s forwards}'
      + '@keyframes lst2Walk{0%{transform:translateX(-14px)}100%{transform:translateX(74px)}}'
      + '.lst2-walk{animation:lst2Walk 7s linear infinite}'
      + '.lst2-fig{animation:lst2Bob 6s ease-in-out infinite}'
      + '.lst2-hL{animation:lst2TA .5s ease-in-out infinite}'
      + '.lst2-d1{animation:lst2Dot 1.6s infinite}.lst2-d2{animation:lst2Dot 1.6s infinite .22s}.lst2-d3{animation:lst2Dot 1.6s infinite .44s}'
      + '.j2-handR{animation:lst2TB .5s ease-in-out infinite, j2HideR 14s linear infinite}'
      + '@keyframes j2HideR{0%,26%{opacity:1}29%,46%{opacity:0}49%,100%{opacity:1}}'
      + '.j2-cup{animation:j2Cup 14s linear infinite}'
      + '@keyframes j2Cup{0%,26%{transform:translate(0,0)}31%,41%{transform:translate(-11px,-15px)}46%,100%{transform:translate(0,0)}}'
      + '.j2-hs{animation:j2HS 14s linear infinite}'
      + '@keyframes j2HS{0%,54%{opacity:0}58%,94%{opacity:1}98%,100%{opacity:0}}'
      + '.j2-n1{animation:j2Note 14s linear infinite}.j2-n2{animation:j2Note 14s linear infinite 1.2s}.j2-n3{animation:j2Note 14s linear infinite 2.4s}'
      + '@keyframes j2Note{0%,60%{opacity:0;transform:translate(0,0)}63%{opacity:1}74%{opacity:0;transform:translate(4px,-11px)}74.1%,100%{opacity:0}}'
      + '.l2-head{transform-origin:32px 22px;animation:l2Bob .8s ease-in-out infinite}'
      + '@keyframes l2Bob{0%,100%{transform:rotate(-4deg)}50%{transform:rotate(4deg)}}'
      + '.l2-handR{animation:lst2TB .5s ease-in-out infinite, l2HideR 14s linear infinite}'
      + '@keyframes l2HideR{0%,64%{opacity:1}67%,84%{opacity:0}87%,100%{opacity:1}}'
      + '.l2-ball{animation:l2Ball 14s linear infinite}'
      + '@keyframes l2Ball{0%,66%{opacity:0;transform:translate(0,0)}68%{opacity:1;transform:translate(0,0)}74%{transform:translate(-14px,-12px)}79%{opacity:1;transform:translate(-26px,3px)}81%,100%{opacity:0}}'
      + '.b2-walk{animation:b2X 12s linear infinite}'
      + '@keyframes b2X{0%{transform:translateX(-12px)}30%{transform:translateX(26px)}70%{transform:translateX(26px)}100%{transform:translateX(66px)}}'
      + '.b2-bob{animation:lst2Bob 1.4s ease-in-out infinite}'
      + '.b2-w{animation:b2ShowW 12s linear infinite}'
      + '@keyframes b2ShowW{0%,29%{opacity:1}31%,69%{opacity:0}71%,100%{opacity:1}}'
      + '.b2-c{animation:b2ShowC 12s linear infinite}'
      + '@keyframes b2ShowC{0%,29%{opacity:0}31%,69%{opacity:1}71%,100%{opacity:0}}'
      + '.b2-la{transform-origin:0 33px;animation:b2Leg .5s ease-in-out infinite, b2ShowW 12s linear infinite}'
      + '.b2-lb{transform-origin:0 33px;animation:b2LegB .5s ease-in-out infinite, b2ShowW 12s linear infinite}'
      + '@keyframes b2Leg{0%,100%{transform:rotate(16deg)}50%{transform:rotate(-16deg)}}'
      + '@keyframes b2LegB{0%,100%{transform:rotate(-16deg)}50%{transform:rotate(16deg)}}'
      + '.b2-axe{transform-origin:6px 26px;animation:b2Chop 1.1s ease-in-out infinite}'
      + '@keyframes b2Chop{0%,12%,100%{transform:rotate(14deg)}55%{transform:rotate(-52deg)}}'
      + '.b2-chip{animation:b2ChipFly 1.1s ease-in-out infinite}'
      + '@keyframes b2ChipFly{0%,55%{opacity:0;transform:translate(0,0)}62%{opacity:1}100%{opacity:0;transform:translate(6px,-8px)}}'
      + '.b2-g1{animation:b2L1 12s linear infinite}.b2-g2{animation:b2L2 12s linear infinite}.b2-g3{animation:b2L3 12s linear infinite}'
      + '@keyframes b2L1{0%,37%{opacity:0}40%,96%{opacity:1}99%,100%{opacity:0}}'
      + '@keyframes b2L2{0%,48%{opacity:0}51%,96%{opacity:1}99%,100%{opacity:0}}'
      + '@keyframes b2L3{0%,59%{opacity:0}62%,96%{opacity:1}99%,100%{opacity:0}}'
      // Enrichissement attente longue (Arnaud 2026-06-12) : plus l'attente dure, plus la scene se peuple.
      // Props enfance a 8s/16s (lst3-a/-b) + cycles rares 24-38s desynchronises de la boucle 12-14s
      // -> sur une reco taille de 20-60s, deux boucles ne se ressemblent jamais.
      + '.lst3-a{opacity:0;animation:lst2In .9s ease 8s forwards}'
      + '.lst3-b{opacity:0;animation:lst2In .9s ease 16s forwards}'
      + '.j3-plane{animation:j3Plane 28s linear infinite}'
      + '@keyframes j3Plane{0%,60%{opacity:0;transform:translate(-12px,22px) rotate(9deg)}61.5%{opacity:1}71%{opacity:1;transform:translate(78px,3px) rotate(-7deg)}72%,100%{opacity:0;transform:translate(78px,3px)}}'
      + '.j3-zz{animation:j3Zz 4s ease-out infinite}'
      + '@keyframes j3Zz{0%{opacity:0;transform:translate(0,0)}30%{opacity:.85}100%{opacity:0;transform:translate(2.4px,-4.5px)}}'
      + '.l3-bf{animation:l3Bf 26s linear infinite}'
      + '@keyframes l3Bf{0%,61%{opacity:0;transform:translate(76px,9px) rotate(0deg)}63%{opacity:1}68%{transform:translate(56px,3px) rotate(-10deg)}73%{transform:translate(48px,11px) rotate(8deg)}78%{opacity:1;transform:translate(60px,1px) rotate(-6deg)}81%,100%{opacity:0;transform:translate(76px,-2px)}}'
      + '.b3-bird{animation:b3Bird 24s linear infinite}'
      + '@keyframes b3Bird{0%,54%{opacity:0;transform:translate(15px,-13px)}56%{opacity:1;transform:translate(0,0)}60%{transform:translate(0,1px)}63%{transform:translate(0,0)}67%{transform:translate(0,1px)}70%,84%{opacity:1;transform:translate(0,0)}88%,100%{opacity:0;transform:translate(16px,-12px)}}'
      + '.b3-cloud{animation:b3Cloud 38s linear infinite}'
      + '@keyframes b3Cloud{0%{transform:translateX(-20px)}100%{transform:translateX(88px)}}'
      // 💭 Phrase perso des agents : AUCUNE regle n'existait -> le texte heritait du CSS du theme
      // Shopify (italique + 1re lettre rognee, bug signale par Arnaud 2026-08-04). On l'isole
      // explicitement : pas d'italique herite, un chouia de padding pour ne rien couper, et on
      // laisse la phrase respirer sur 2 lignes si besoin plutot que de la tronquer.
      + '.ls-agent-card .quote{font-style:normal!important;font-size:11.5px;line-height:1.35;'
      + 'color:rgba(255,255,255,.92);margin-top:5px;padding:0 2px;white-space:normal;overflow:visible;'
      + 'text-overflow:clip;letter-spacing:.1px;opacity:.95}'
      + '</style>';
    var BG = '<g class="lst2-bg"><g class="lst2-walk" opacity=".5"><circle cx="6" cy="17" r="3" fill="#aab2c0"/><path d="M3 20h6v8a1.5 1.5 0 0 1 -1.5 1.5h-3a1.5 1.5 0 0 1 -1.5 -1.5z" fill="#aab2c0"/><rect x="3.4" y="29" width="2" height="6" rx="1" fill="#aab2c0"/><rect x="6.6" y="29" width="2" height="6" rx="1" fill="#aab2c0"/></g><g transform="translate(61,29)"><path d="M2 9h8l-1.2 8h-5.6z" fill="#C8794B"/><ellipse cx="6" cy="5.5" rx="3" ry="5.5" fill="#3FA45B"/><ellipse cx="2.6" cy="8" rx="2.3" ry="4" fill="#4FBF6A" transform="rotate(-22 2.6 8)"/><ellipse cx="9.4" cy="8" rx="2.3" ry="4" fill="#4FBF6A" transform="rotate(22 9.4 8)"/></g></g>';
    var DOTS = '<circle class="lst2-d1" cx="50" cy="8" r="1.9" fill="#9aa3b2"/><circle class="lst2-d2" cx="55.5" cy="8" r="1.9" fill="#9aa3b2"/><circle class="lst2-d3" cx="61" cy="8" r="1.9" fill="#9aa3b2"/>';
    var fig;
    if (p === "ben") {
      var tree = function (x, h) { return '<g transform="translate(' + x + ',0)"><rect x="-1.5" y="33" width="3" height="9" fill="#7A4A25"/><polygon points="0,' + h + ' -8,31 8,31" fill="#2F7D4F"/><polygon points="0,' + (h + 7) + ' -6.5,35 6.5,35" fill="#3FA45B"/></g>'; };
      fig = '<rect x="0" y="42" width="72" height="6" fill="#CDE6C2"/>' + tree(10, 14) + tree(60, 12) + tree(40, 17)
        + '<g><rect class="b2-g1" x="5" y="40" width="6.5" height="2.6" rx="1.2" fill="#8a5a2e"/><rect class="b2-g2" x="6" y="37.6" width="6.5" height="2.6" rx="1.2" fill="#9a6636"/><rect class="b2-g3" x="7" y="35.2" width="6.5" height="2.6" rx="1.2" fill="#8a5a2e"/></g>'
        + '<g class="b2-walk"><g class="b2-bob">'
        + '<line class="b2-la" x1="0" y1="33" x2="-2.5" y2="42" stroke="#3A567E" stroke-width="2.6" stroke-linecap="round"/>'
        + '<line class="b2-lb" x1="0" y1="33" x2="2.5" y2="42" stroke="#3A567E" stroke-width="2.6" stroke-linecap="round"/>'
        + '<g class="b2-c"><line x1="-2" y1="33" x2="-2.6" y2="42" stroke="#3A567E" stroke-width="2.6" stroke-linecap="round"/><line x1="2" y1="33" x2="2.6" y2="42" stroke="#3A567E" stroke-width="2.6" stroke-linecap="round"/></g>'
        + '<rect x="-4.5" y="23" width="9" height="11" rx="2.5" fill="#C0392B" stroke="#7a1f15" stroke-width=".8"/>'
        + '<path d="M-2.5 24 v10 M-4.5 28 h9" stroke="#3a1410" stroke-width=".8" opacity=".4"/>'
        + '<path d="M-3 24 l.5 10 M3 24 l-.5 10" stroke="#4C6EA8" stroke-width="2"/>'
        + '<g class="b2-w"><line x1="2" y1="26" x2="9" y2="18" stroke="#7A4A25" stroke-width="1.6" stroke-linecap="round"/><polygon points="8,19 12.5,16.5 13.5,20 9,22" fill="#C2CAD6" stroke="#6b7280" stroke-width=".5"/></g>'
        + '<g class="b2-c">'
        + '<rect x="9" y="39.4" width="8" height="3" rx="1.2" fill="#8a5a2e"/>'
        + '<line x1="1" y1="25" x2="6" y2="26" stroke="#C0392B" stroke-width="2.4" stroke-linecap="round"/>'
        + '<g class="b2-axe"><line x1="6" y1="26" x2="13" y2="20" stroke="#7A4A25" stroke-width="1.6" stroke-linecap="round"/><polygon points="12,21 16.5,18.5 17.5,22 13,24" fill="#C2CAD6" stroke="#6b7280" stroke-width=".5"/></g>'
        + '<polygon class="b2-chip" points="14,38 16.2,37 15,39.6" fill="#C8794B"/>'
        + '</g>'
        + '<path d="M-1.5 15 q-5 1.5 -5.4 6.6 q-.3 3.4 .8 6.6 q-.5 1.8 .6 3.6 l1.8 -.5 q-.9 -1.6 -.3 -3.3 q-1 -2.8 -.7 -5.7 q.4 -3.4 3.7 -4.8 z" fill="#5A3D26"/>'
        + '<path d="M4.6 16 q1.4 1.6 .8 5.4 q-.2 3 .6 5.4 l-1.7 .3 q-.7 -2.6 -.5 -5.4 q.3 -3.4 -.9 -5.2 z" fill="#4E331F"/>'
        + '<circle cx="0" cy="19" r="4.6" fill="#F1C9A5"/>'
        + '<path d="M-4.7 17.6 q-1.3 -5.4 4.7 -6.2 q6 .8 4.7 6.2 q-1.4 -2.8 -3 -2.2 q.3 -1.8 -1.7 -2 q-2 .2 -1.7 2 q-1.6 -.6 -3 2.2 z" fill="#5A3D26"/>'
        + '<path d="M-4.6 18 a4.6 4.6 0 0 1 9.2 0 l0 6 -1.6 0 -.6 -5 q-2.5 1.5 -4.4 0 l-.6 5 -1.6 0z" fill="#5A3D26"/>'
        + '<circle cx="-1.6" cy="19" r=".85" fill="#5A3D26"/><circle cx="-1.6" cy="19.1" r=".42" fill="#1c1206"/>'
        + '</g></g>'
        + '<g class="b3-cloud" opacity=".55"><ellipse cx="2" cy="6.5" rx="5" ry="2.1" fill="#dceefb"/><ellipse cx="6" cy="5.4" rx="3.4" ry="1.7" fill="#dceefb"/></g>'
        + '<g class="lst3-a"><g transform="translate(17,38.8)"><rect x="-.8" y="1.3" width="1.6" height="2.7" rx=".5" fill="#f3e7d3"/><path d="M-2.6 1.6 a2.6 2.6 0 0 1 5.2 0z" fill="#C0392B"/><circle cx="-1" cy=".55" r=".32" fill="#fff"/><circle cx=".9" cy=".9" r=".3" fill="#fff"/></g></g>'
        + '<g class="lst3-b"><g transform="translate(55.4,39.6)"><line x1="0" y1="0" x2="0" y2="2.8" stroke="#3da04c" stroke-width=".55"/><circle cx="-.85" cy="-.4" r=".72" fill="#ff8ac2"/><circle cx=".85" cy="-.4" r=".72" fill="#ff8ac2"/><circle cx="0" cy="-1.15" r=".72" fill="#ff8ac2"/><circle cx="0" cy="-.5" r=".5" fill="#F4C84B"/></g></g>'
        + '<g class="b3-bird"><g transform="translate(40,15.2)"><ellipse cx="0" cy="0" rx="1.9" ry="1.4" fill="#5BA8E0"/><circle cx="1.5" cy="-.9" r="1" fill="#5BA8E0"/><polygon points="2.4,-.9 3.5,-.6 2.4,-.3" fill="#F4A93B"/><circle cx="1.8" cy="-1.1" r=".25" fill="#222"/><path d="M-.5 -.3 q-1.5 -1 -2.3 0 q1 .9 2.3 .7z" fill="#3E86C2"/></g></g>';
    } else {
      var blonde = (p !== "louise");
      var hair = blonde ? "#F4C84B" : "#6B4A2B";
      var hairD = blonde ? "#E0A92E" : "#503422";   // ombre cheveux (meche basse)
      var torso = blonde ? "#4C6EA8" : "#D24A4A";
      var iris = blonde ? "#3E78C0" : "#6E4A2A";    // Juliette yeux bleus, Louise yeux marron
      var face = '<circle cx="29" cy="16.4" r="1.3" fill="#fff"/><circle cx="35" cy="16.4" r="1.3" fill="#fff"/>'
        + '<circle cx="29.1" cy="16.5" r="1.05" fill="' + iris + '"/><circle cx="35.1" cy="16.5" r="1.05" fill="' + iris + '"/>'
        + '<circle cx="29.2" cy="16.65" r=".5" fill="#16263a"/><circle cx="35.2" cy="16.65" r=".5" fill="#16263a"/>'
        + '<circle cx="28.7" cy="16.05" r=".3" fill="#fff"/><circle cx="34.7" cy="16.05" r=".3" fill="#fff"/>';
      var straps = blonde
        ? '<line x1="28" y1="26.5" x2="29" y2="34" stroke="#2E4470" stroke-width="1"/><line x1="36" y1="26.5" x2="35" y2="34" stroke="#2E4470" stroke-width="1"/><circle cx="28.5" cy="28.5" r="1" fill="#F4D06A"/><circle cx="35.5" cy="28.5" r="1" fill="#F4D06A"/>'
        : '<path d="M28 26 l1 9 M36 26 l-1 9" stroke="#4C6EA8" stroke-width="2.2"/><rect x="28" y="33" width="8" height="4" fill="#4C6EA8"/><circle cx="28.7" cy="28" r="1" fill="#F4D06A"/><circle cx="35.3" cy="28" r="1" fill="#F4D06A"/>';
      var hsHTML = '<path d="M24.5 12.6 a7.5 7.5 0 0 1 15 0" fill="none" stroke="#3a3f4a" stroke-width="2.2" stroke-linecap="round"/><rect x="22.6" y="13.2" width="3.4" height="6" rx="1.6" fill="#3a3f4a"/><rect x="38" y="13.2" width="3.4" height="6" rx="1.6" fill="#3a3f4a"/>';
      var headHTML =
        '<path d="M22 16 a10 10 0 0 1 20 0 q.7 8 -1.1 13 l-3 -.6 q1.6 -5.6 .8 -10.6 q-6.6 3.6 -13.2 0 q-.8 5 .8 10.6 l-3 .6 q-1.8 -5 -1.1 -13 z" fill="' + hair + '"/>'
        + '<path d="M22.6 22 q-.2 4 1.1 7.4 l2.1 -.5 q-1.4 -3.5 -1.1 -7.1 z" fill="' + hairD + '"/>'
        + '<path d="M41.4 22 q.2 4 -1.1 7.4 l-2.1 -.5 q1.4 -3.5 1.1 -7.1 z" fill="' + hairD + '"/>'
        + '<circle cx="32" cy="17" r="8" fill="#F1C9A5"/>'
        + '<path d="M23.6 15 q8.4 -6 16.8 0 q-2.6 -5 -8.4 -5 q-5.8 0 -8.4 5 z" fill="' + hair + '"/>'
        + '<path d="M24.6 14.6 q7.4 -3.8 14.8 0 q-7.4 -2.1 -14.8 0 z" fill="' + hairD + '"/>'
        + face
        + '<path d="M29.8 21.3 q2.2 1.8 4.4 0" stroke="#C9866B" stroke-width="1.1" fill="none" stroke-linecap="round"/>';
      var headWrap, extras, handR;
      if (blonde) {
        headWrap = headHTML + '<g class="j2-hs">' + hsHTML
          + '<text class="j2-n1" x="43" y="13" font-size="6" fill="#7a3fd0">&#9834;</text>'
          + '<text class="j2-n2" x="47" y="16" font-size="5" fill="#a06bff">&#9834;</text>'
          + '<text class="j2-n3" x="40" y="11" font-size="5" fill="#5fd06a">&#9834;</text></g>';
        extras = '<g class="j2-cup"><rect x="46" y="30.4" width="5" height="5" rx="1" fill="#fff" stroke="#b9876b" stroke-width=".8"/><path d="M51 31.4 q2.4 1.1 0 3.2" fill="none" stroke="#b9876b" stroke-width=".8"/><path d="M47.2 29.6 q.8 -1 0 -1.8 M49.2 29.6 q.8 -1 0 -1.8" stroke="#ccc" stroke-width=".6" fill="none" opacity=".85"/></g>'
          + '<g class="lst3-a"><rect x="3" y="45.6" width="7" height="2" rx=".6" fill="#F4C84B" stroke="#d9a92e" stroke-width=".5"/><rect x="3.8" y="43.7" width="5.8" height="2" rx=".6" fill="#5fd06a" stroke="#3da04c" stroke-width=".5"/></g>'
          + '<g class="lst3-b"><g transform="translate(30,44.3)"><ellipse cx="0" cy="1.3" rx="3.1" ry="1.6" fill="#cdc7bf"/><circle cx="2.7" cy=".4" r="1.3" fill="#cdc7bf"/><polygon points="1.9,-.6 2.3,-1.7 2.9,-.7" fill="#cdc7bf"/><polygon points="3.5,-.6 3.9,-1.6 4.3,-.5" fill="#cdc7bf"/><path d="M-2.9 1.9 q-1.7 -.6 -1 -2.1" stroke="#cdc7bf" stroke-width=".8" fill="none" stroke-linecap="round"/><text class="j3-zz" x="4.4" y="-2.2" font-size="3.2" fill="#9aa3b2">z</text></g></g>'
          + '<g class="j3-plane"><polygon points="0,0 7,2.4 0,4.8 1.7,2.4" fill="#eef4ff" stroke="#9fb4e8" stroke-width=".6"/></g>';
        handR = '<g class="j2-handR"><ellipse cx="46" cy="34.5" rx="3" ry="2.3" fill="#F1C9A5" stroke="#D8A982" stroke-width=".8"/></g>';
      } else {
        headWrap = '<g class="l2-head">' + headHTML + hsHTML
          + '<text class="j2-n1" x="43" y="13" font-size="6" fill="#7a3fd0">&#9834;</text>'
          + '<text class="j2-n2" x="46.5" y="16" font-size="5" fill="#ff5ca8">&#9834;</text></g>';
        extras = '<path d="M12.5 37.4 h6 l-.8 6.6 h-4.4 z" fill="#94a3ba"/><rect x="12" y="36.5" width="7" height="1.4" rx=".7" fill="#7e8ca0"/>'
          + '<circle class="l2-ball" cx="45" cy="32.5" r="1.7" fill="#eceff4" stroke="#b9c2cf" stroke-width=".6"/>'
          + '<g class="lst3-a"><rect x="2.6" y="2.4" width="10.6" height="8.4" rx="1" fill="#fffdf4" stroke="#e6dcbd" stroke-width=".6"/><circle cx="7.9" cy="2.9" r=".42" fill="#d83b50"/><circle cx="5.5" cy="5.2" r="1.25" fill="#F4C84B"/><path d="M3.8 9.4 l1.5 -1.7 1.5 1.7 1.3 -1.3 1.5 1.3" stroke="#5fd06a" stroke-width=".6" fill="none"/><path d="M10.4 5.9 a.65 .65 0 0 1 1.3 0 q0 .75 -1.3 1.5 q-1.3 -.75 -1.3 -1.5 a.65 .65 0 0 1 1.3 0z" fill="#ff6b81"/></g>'
          + '<g class="l3-bf"><ellipse cx="-1.4" cy="0" rx="1.5" ry="2.1" fill="#ff8ac2"/><ellipse cx="1.4" cy="0" rx="1.5" ry="2.1" fill="#ffa9d4"/><line x1="0" y1="-1.9" x2="0" y2="1.9" stroke="#7a3fd0" stroke-width=".7" stroke-linecap="round"/></g>';
        handR = '<g class="l2-handR"><ellipse cx="46" cy="34.5" rx="3" ry="2.3" fill="#F1C9A5" stroke="#D8A982" stroke-width=".8"/></g>';
      }
      fig = '<rect x="12" y="36" width="40" height="8" rx="3" fill="#D8DEE9" stroke="#B7C0D0" stroke-width="1"/><line x1="17" y1="40" x2="47" y2="40" stroke="#B7C0D0" stroke-width="1.2" stroke-dasharray="2 2"/>'
        + '<g class="lst2-fig"><path d="M25 29l-7 6" stroke="' + torso + '" stroke-width="3.4" stroke-linecap="round"/><path d="M39 29l7 6" stroke="' + torso + '" stroke-width="3.4" stroke-linecap="round"/><path d="M23 28 q9 -5 18 0 l2 9 h-22 z" fill="' + torso + '" stroke="#2E4470" stroke-width="1.2" stroke-linejoin="round"/>' + straps + headWrap + '</g>'
        + extras
        + '<g class="lst2-hL"><ellipse cx="18" cy="34.5" rx="3" ry="2.3" fill="#F1C9A5" stroke="#D8A982" stroke-width=".8"/></g>' + handR;
    }
    return '<div class="ls-typing-sal" style="display:flex;align-items:center;justify-content:center;padding:1px 2px"><svg width="52" height="35" viewBox="0 0 72 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style="overflow:visible">' + STYLE + (p === "ben" ? "" : BG) + fig + DOTS + '</svg></div>';
  }
  function showTyping() {
    var t = document.getElementById("ls-thread");
    if (!t) return;
    var typ = el("div", { class: "ls-msg assistant", id: "ls-typing" }, [
      msgAvatarEl(),
      el("div", { class: "ls-msg-bubble", html: _typingSceneSVG() })
    ]);
    t.appendChild(typ);
    scrollThread();
  }
  function hideTyping() {
    var typ = document.getElementById("ls-typing");
    if (typ) typ.remove();
  }

  // Affiche une liste de bulles l'une apres l'autre, avec un faux temps de frappe entre chaque
  // (humanisation Arnaud 2026-05-31). La 1ere apparait vite ; les suivantes apres ~delay simule.
  function renderBubblesSequentially(bubbles, delays, onDone) {
    var i = 0;
    function pushOne() {
      state.messages.push({ role: "assistant", content: bubbles[i] });
      renderThread();
      i++;
      if (i >= bubbles.length) { if (onDone) onDone(); return; }
      // temps de frappe avant la bulle suivante (borne 500..3500ms), legerement + rapide qu'un humain
      var wait = (delays && delays[i]) ? Math.max(500, Math.min(delays[i], 3500)) : 1200;
      showTyping();
      setTimeout(function () { hideTyping(); pushOne(); }, wait);
    }
    pushOne();
  }

  // ===== PIECES JOINTES IMAGE =====
  function handleImageFile(file) {
    if (!file || (file.type || "").indexOf("image/") !== 0) return;
    if (file.size > 5 * 1024 * 1024) { renderImagePreview("too-big"); return; }
    var reader = new FileReader();
    reader.onload = function (ev) { state.pendingImage = ev.target.result; renderImagePreview(); };
    reader.readAsDataURL(file);
  }
  function clearPendingImage() { state.pendingImage = null; renderImagePreview(); }
  function renderImagePreview(err) {
    var bar = document.getElementById("ls-img-preview");
    if (!bar) return;
    bar.innerHTML = "";
    if (err === "too-big") {
      bar.appendChild(el("div", { class: "ls-img-err", html: "Image trop lourde (5 Mo max)" }));
      bar.style.display = "flex";
      setTimeout(function () { if (!state.pendingImage) { var b2 = document.getElementById("ls-img-preview"); if (b2) { b2.innerHTML = ""; b2.style.display = "none"; } } }, 3000);
      return;
    }
    if (state.pendingImage) {
      var chip = el("div", { class: "ls-img-chip" });
      var im = document.createElement("img"); im.src = state.pendingImage; chip.appendChild(im);
      chip.appendChild(el("button", { class: "ls-img-x", "aria-label": "Retirer l'image", onclick: clearPendingImage, html: "&times;" }));
      bar.appendChild(chip);
      bar.style.display = "flex";
    } else {
      bar.style.display = "none";
    }
  }

  function sendFromInput() {
    var i = document.getElementById("ls-input");
    if (!i) return;
    var v = (i.value || "").trim();
    if (!v && !state.pendingImage) return;  // texte OU image requis
    i.value = "";
    i.style.height = "auto";
    _emitVisitorTyping();  // brouillon vide -> Louise efface la preview live
    var img = state.pendingImage || null;
    clearPendingImage();
    sendVisitorMessage(v, img);
  }

  function sendVisitorMessage(text, image) {
    if (!consentGranted()) return; // visitor needs to accept cookies first (silent no-op)
    goView("chat");
    state.messages.push({ role: "user", content: text, image: image || null });
    renderThread();
    persistSession();
    reEnable(); reArm(); reRequestNotif(); // engagement : (re)arme l'inactivite + propose les notifs OS
    // Attribution agent dès l'envoi : un opérateur prend la conv (sa bulle grossit, les autres rétrécissent)
    if (typeof state.assignedAgent !== "number") assignAgent();
    applyAssignmentVisual();
    // 🚨 Le message s'affiche TOUJOURS, jamais d'evaporation (Arnaud 2026-06-05 : un message envoye PENDANT
    // que le bot repond disparaissait). Si le bot est en train de repondre, on met en FILE et on envoie des
    // qu'il est libre -> le client peut toujours ecrire.
    if (state.sending) {
      state.queue = state.queue || [];
      state.queue.push({ text: text, image: image || null });
      return;
    }
    _sendToBackend(text, image);
  }

  function _flushQueue() {
    if (state.queue && state.queue.length) {
      var nx = state.queue.shift();
      _sendToBackend(nx.text, nx.image);
    }
  }

  function rateLimitMsg() {
    var l = (CFG.locale || "fr").slice(0, 2).toLowerCase();
    var m = {
      fr: "Petit instant, je recois beaucoup de messages la. Reessayez dans quelques secondes, je suis a vous tout de suite.",
      de: "Einen kurzen Moment bitte, gerade kommen viele Nachrichten an. Versuchen Sie es in ein paar Sekunden erneut, ich bin gleich fuer Sie da.",
      it: "Un attimo, sto ricevendo molti messaggi in questo momento. Riprovi tra qualche secondo, sono subito da lei.",
      es: "Un momento, ahora mismo recibo muchos mensajes. Vuelva a intentarlo en unos segundos, enseguida le atiendo.",
      nl: "Een ogenblikje, ik ontvang nu veel berichten. Probeer het over een paar seconden opnieuw, ik help u zo.",
      en: "One moment, I'm getting a lot of messages right now. Please try again in a few seconds, I'll be right with you."
    , pl: "Chwileczkę, dostaję teraz dużo wiadomości. Spróbuj ponownie za kilka sekund, zaraz się Tobą zajmę." };
    return m[l] || m.fr;
  }

  // 🛒 Tague le panier Shopify "_ls_chat" des que le visiteur ECHANGE avec le bot -> la commande herite
  // du note_attribute -> attribution ventes assistees fiable MEME sans email (Arnaud 2026-06-07).
  // URL relative = origine storefront (la-salopette.fr), pas Railway. 404 silencieux en sandbox.
  function _tagCartChatted() {
    // Arnaud 2026-06-10 (audit 0EUR ventes assistees) : avant = tag UNE seule fois, souvent sur panier VIDE
    // (le client chatte la taille AVANT d'ajouter au panier) -> tag perdu si le panier est recree ensuite.
    // Desormais on RE-tague a chaque message (throttle 20s) -> le tag survit aux ajouts/operations panier.
    var _nowTag = Date.now();
    if (state.chatTaggedAt && (_nowTag - state.chatTaggedAt) < 20000) return;
    state.chatTaggedAt = _nowTag;
    try {
      // _ls_vid = visitor_id -> la commande herite du tag -> Louise relie la CONV a la VENTE (badge vendu).
      fetch("/cart/update.js", {
        method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: { "_ls_chat": "1", "_ls_vid": lsVisitorId() } })
      }).catch(function () {});
    } catch (e) {}
  }
  function _sendToBackend(text, image, attempt) {
    state.sending = true;
    if (!attempt) _tagCartChatted();
    showTyping();
    fetch(CFG.apiBase + "/api/chat/message", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        session_id: state.sessionId,
        message: text,
        locale: CFG.locale,
        market: CFG.market,
        page_url: location.href,
        customer_email: state.customerEmail,
        visitor_id: lsVisitorId(),  // lie le chat au parcours de navigation (beacon) pour /louise
        agent_name: (CFG.avatars && typeof state.assignedAgent === "number" && CFG.avatars[state.assignedAgent] && CFG.avatars[state.assignedAgent].name) || undefined,  // agent EN LIGNE vu par le client -> identite genrée cote backend (Ben=conseiller m, Juliette/Louise=conseillère f)
        image: image || undefined
      })
    })
      .then(function (r) {
        var st = r.status;
        return r.json().then(function (j) { j = j || {}; j.__status = st; return j; }, function () { return { __status: st }; });
      })
      .then(function (j) {
        // 429 = trop de requetes : 1 auto-retry silencieux apres 6s (le quota /min se libere
        // vite), puis message clair localise (sans em-dash) si ca persiste.
        if (j && j.__status === 429) {
          if (!attempt) { setTimeout(function () { _sendToBackend(text, image, 1); }, 6000); return; }
          hideTyping(); state.sending = false;
          state.messages.push({ role: "assistant", content: rateLimitMsg() });
          renderThread(); _flushQueue(); persistSession();
          return;
        }
        hideTyping();
        if (j && j.session_id) state.sessionId = j.session_id;
        // AI muted = human took over → show banner + start polling for human replies
        if (j && j.ai_muted) {
          showHumanTakeoverBanner();
          state.lastPollTs = new Date().toISOString();
          startHumanPolling();
          persistSession();
          state.sending = false; _flushQueue();
          return;
        }
        var reply = (j && j.reply) || "Je n'ai pas pu repondre. Pouvez-vous reformuler ?";
        // Remember when last assistant msg arrived (for poll cursor if human takes over later)
        state.lastPollTs = new Date().toISOString();
        // Humanisation (Arnaud 2026-05-31) : affiche les bulles l'une apres l'autre avec faux
        // temps de frappe si le backend a decoupe le message ; sinon 1 seule bulle.
        var bubbles = (j && j.bubbles && j.bubbles.length) ? j.bubbles : [reply];
        var delays = (j && j.bubble_delays_ms && j.bubble_delays_ms.length === bubbles.length) ? j.bubble_delays_ms : null;
        // sending reste vrai PENDANT le rendu sequentiel des bulles -> un message tape entre-temps est mis
        // en file (s'affiche deja) puis envoye quand le bot a fini. Libere + flush a la fin.
        renderBubblesSequentially(bubbles, delays, function () { persistSession(); reArm(); state.sending = false; _flushQueue(); });
      })
      .catch(function (e) {
        hideTyping();
        state.sending = false;
        state.messages.push({
          role: "assistant",
          content: "Le service est momentanement indisponible. Vous pouvez ecrire a contact@la-salopette.fr, Laura repondra sous 24h ouvrees."
        });
        renderThread();
        _flushQueue();
        persistSession();
      });
  }

  function showBadge(n) {
    var b = document.getElementById("ls-fab-badge");
    if (!b) return;
    b.textContent = String(n);
    b.classList.add("visible");
  }
  function hideBadge() {
    var b = document.getElementById("ls-fab-badge");
    if (b) b.classList.remove("visible");
  }

  // ====== Human take-over banner + polling ======
  var humanPollTimer = null;

  function showHumanTakeoverBanner() {
    var existing = document.getElementById("ls-human-banner");
    if (existing) return;
    var panel = document.querySelector(".ls-panel");
    if (!panel) return;
    var banner = document.createElement("div");
    banner.id = "ls-human-banner";
    banner.style.cssText = "padding:8px 12px;background:linear-gradient(135deg,#10B981,#065F46);color:#fff;font-size:13px;font-weight:600;text-align:center;border-radius:8px;margin:8px 12px;animation:fadeIn .3s";
    banner.innerHTML = "👋 Un humain de l'équipe a pris la main, il vous répond directement…";
    var thread = panel.querySelector(".ls-thread");
    if (thread) thread.parentNode.insertBefore(banner, thread);
  }

  function hideHumanTakeoverBanner() {
    var b = document.getElementById("ls-human-banner");
    if (b) b.remove();
  }

  function startHumanPolling() {
    if (humanPollTimer) return;
    humanPollTimer = setInterval(function () {
      if (!state.sessionId) return;
      var since = state.lastPollTs || "";
      // Parallel poll : new msgs + typing state
      Promise.all([
        fetch(CFG.apiBase + "/api/chat/session/" + state.sessionId + "/poll?since=" + encodeURIComponent(since)).then(function (r) { return r.json(); }),
        fetch(CFG.apiBase + "/api/chat/session/" + state.sessionId + "/typing").then(function (r) { return r.json(); })
      ]).then(function (res) {
        var pollRes = res[0] || {}, typingRes = res[1] || {};
        var items = pollRes.items || [];
        if (items.length) {
          items.forEach(function (it) {
            state.messages.push({ role: "assistant", content: it.content, sent_by: it.sent_by, image: it.image || undefined });
            state.lastPollTs = it.ts || state.lastPollTs;
          });
          renderThread();
          persistSession();
          var panel = document.querySelector(".ls-panel");
          if (panel && !panel.classList.contains("open")) showBadge(items.length);
          hideHumanTyping(); // received reply → no longer typing
        }
        // Typing indicator
        if (typingRes.typing && !items.length) showHumanTyping();
        else if (!typingRes.typing) hideHumanTyping();
        // Take-over released
        if (!pollRes.taken_over) {
          stopHumanPolling();
          hideHumanTakeoverBanner();
          hideHumanTyping();
        }
      }).catch(function () {});
    }, 4000);
  }

  function showHumanTyping() {
    if (document.getElementById("ls-human-typing")) return;
    var thread = document.querySelector(".ls-thread");
    if (!thread) return;
    var dots = document.createElement("div");
    dots.id = "ls-human-typing";
    dots.style.cssText = "display:flex;align-items:center;gap:6px;padding:8px 14px;margin:4px 0;font-size:12px;color:#10B981;font-style:italic";
    dots.innerHTML = "<span style='display:inline-flex;gap:3px'><span class='lsd' style='width:6px;height:6px;border-radius:50%;background:#10B981;animation:lsDot 1.2s infinite ease-in-out'></span><span class='lsd' style='width:6px;height:6px;border-radius:50%;background:#10B981;animation:lsDot 1.2s infinite ease-in-out;animation-delay:.2s'></span><span class='lsd' style='width:6px;height:6px;border-radius:50%;background:#10B981;animation:lsDot 1.2s infinite ease-in-out;animation-delay:.4s'></span></span> Un humain de l'équipe écrit…";
    thread.appendChild(dots);
    thread.scrollTop = thread.scrollHeight;
  }
  function hideHumanTyping() {
    var el = document.getElementById("ls-human-typing");
    if (el) el.remove();
  }

  function stopHumanPolling() {
    if (humanPollTimer) { clearInterval(humanPollTimer); humanPollTimer = null; }
  }

  // ====== Init ======
  // ============== PROACTIVE TRIGGERS PAGE-AWARE ==============
  // Détecte la page + injecte un message pré-rempli si pattern URL match
  var PROACTIVE_TRIGGERS = [
    {
      name: "size_guide",
      delay_ms: 8000,
      cta: "input",
      url_re: /(guide-des-tailles|latzhosen-grossenfuhrer|guida-alle-taglie|guia-de-tallas|maattabel|size-guide|grossentabelle)/i,
      messages: {
        fr: "Besoin d'aide pour choisir votre taille ? 🧵 Donnez-moi votre taille (cm), votre poids (kg) et les modèles qui vous plaisent, je vous guide.",
        de: "Hilfe bei der Größenwahl ? 🧵 Teilen Sie mir Ihre Körpergröße (cm), Ihr Gewicht (kg) und Ihre Wunschmodelle mit, ich berate Sie !",
        it: "Ti serve aiuto con la taglia ? 🧵 Dimmi la tua altezza (cm), il peso (kg) e i modelli che ti piacciono, ti guido io !",
        es: "¿Necesitas ayuda con la talla ? 🧵 Dime tu altura (cm), tu peso (kg) y los modelos que te gustan, yo te oriento !",
        nl: "Hulp nodig bij je maat ? 🧵 Geef je lengte (cm), gewicht (kg) en de modellen die je leuk vindt, ik help je !",
        en: "Need help finding your size ? 🧵 Tell me your height (cm), weight (kg) and the styles you like, I'll guide you !",
        da: "Brug for hjælp til størrelsen ? 🧵 Fortæl mig din højde (cm), vægt (kg) og de modeller, du kan lide !",
        sv: "Behöver du hjälp med storleken ? 🧵 Berätta din längd (cm), vikt (kg) och modellerna du gillar !",
        ja: "サイズ選びでお困りですか？🧵 身長（cm）、体重（kg）、お好みのモデルを教えてください。ご案内します！",
        ko: "사이즈 선택을 도와드릴까요? 🧵 키(cm), 몸무게(kg), 마음에 드는 모델을 알려주시면 안내해 드릴게요!",
        pl: "Potrzebujesz pomocy z rozmiarem ? 🧵 Podaj wzrost (cm), wagę (kg) i modele, które Ci się podobają !",
        pt: "Precisa de ajuda com o tamanho ? 🧵 Diga-me a sua altura (cm), o peso (kg) e os modelos que gosta !",
        ru: "Нужна помощь с размером ? 🧵 Укажите рост (см), вес (кг) и модели, которые вам нравятся !",
        zh: "需要帮您选尺码吗？🧵 告诉我您的身高（厘米）、体重（公斤）和喜欢的款式，我来为您推荐！",
        hr: "Trebate pomoć s veličinom ? 🧵 Recite mi svoju visinu (cm), težinu (kg) i modele koji vam se sviđaju !",
      }
    },
    {
      name: "express_collection",
      delay_ms: 12000,
      url_re: /\/collections\/livraison-express|spedizione-express|express-lieferung|envio-express/i,
      messages: {
        // Formulation Arnaud 2026-08-03 : phrase simple et positive, le delai en avant, drapeau du
        // pays du client a la fin ({d} = 2-3 en FR / 3-6 ailleurs, {f} = drapeau, deja gerés).
        fr: "Nos Livraisons Express arrivent sous {d} jours ouvrés {f}",
        en: "Our Express orders arrive within {d} working days {f}",
        de: "Unsere Express-Lieferungen sind in {d} Werktagen bei Ihnen {f}",
        it: "Le nostre consegne Express arrivano in {d} giorni lavorativi {f}",
        es: "Nuestros envíos Express llegan en {d} días laborables {f}",
        nl: "Onze Express-leveringen zijn er binnen {d} werkdagen {f}",
        pl: "Nasze dostawy Express docierają w {d} dni robocze {f}",
        dk: "Vores Express-leveringer kommer frem på {d} hverdage {f}",
        se: "Våra Express-leveranser kommer fram på {d} arbetsdagar {f}",
        pt: "As nossas entregas Express chegam em {d} dias úteis {f}",
        ja: "エクスプレス便は{d}営業日でお届けします {f}",
        ko: "익스프레스 배송은 {d}영업일 안에 도착합니다 {f}",
        hr: "Naše Express dostave stižu u roku od {d} radna dana {f}"
      }
    },
    // 🚫 trigger proactif "return_policy" RETIRE (Arnaud 2026-06-19) : NE PAS pousser le retour de facon
    // proactive (ca facilite/encourage les retours). Le bot aide au retour UNIQUEMENT si le client le DEMANDE.
    {
      name: "contact_page",
      delay_ms: 5000,
      url_re: /\/pages\/(contact|nous-contacter|kontaktieren-sie-uns|contattaci|contactanos|kontakt)/i,
      messages: {
        fr: "Hey 👋 Je peux peut-être aider...",
        en: "Hey 👋 Maybe I can help...",
        de: "Hey 👋 Vielleicht kann ich helfen...",
        it: "Hey 👋 Forse posso aiutare...",
        es: "Hey 👋 Quizás pueda ayudar...",
        nl: "Hey 👋 Misschien kan ik helpen...",
        da: "Hey 👋 Måske kan jeg hjælpe...",
        sv: "Hey 👋 Kanske kan jag hjälpa...",
        pt: "Hey 👋 Talvez eu possa ajudar...",
        pl: "Hey 👋 Może mogę pomóc...",
        ru: "Hey 👋 Может, я помогу...",
        ja: "Hey 👋 お手伝いできるかも...",
        ko: "Hey 👋 도와드릴 수 있어요...",
        zh: "Hey 👋 也许我能帮忙...",
        hr: "Hey 👋 Možda mogu pomoći..."
      }
    },
    {
      name: "welcome",
      delay_ms: 10000,
      url_re: /.*/,
      messages: {
        fr: "Hey 👋 Je suis là si besoin ☺️",
        en: "Hey 👋 I'm right here if you need me ☺️",
        de: "Hey 👋 Ich bin da, falls Sie was brauchen ☺️",
        it: "Hey 👋 Sono qui se ha bisogno ☺️",
        es: "Hey 👋 Estoy aquí si necesita algo ☺️",
        nl: "Hey 👋 Ik ben er als u me nodig hebt ☺️",
        da: "Hey 👋 Jeg er her, hvis du har brug for hjælp ☺️",
        sv: "Hey 👋 Jag finns här om du behöver ☺️",
        pt: "Hey 👋 Estou aqui se precisar ☺️",
        pl: "Hej 👋 Jestem tu, gdyby czegoś było trzeba ☺️",
        ru: "Привет 👋 Я рядом, если что ☺️",
        ja: "やあ 👋 お気軽にどうぞ ☺️",
        ko: "안녕하세요 👋 필요하시면 불러주세요 ☺️",
        zh: "嗨 👋 有需要随时找我 ☺️",
        hr: "Hej 👋 Tu sam ako trebate ☺️",
      }
    },
  ];

  function detectLocale() {
    // Try : <html lang>, navigator.language, fallback fr
    var htmlLang = (document.documentElement.lang || "").toLowerCase().split("-")[0];
    if (htmlLang) return htmlLang;
    var nav = (navigator.language || "fr").toLowerCase().split("-")[0];
    return nav;
  }

  function pickMessage(messages, locale) {
    return messages[locale] || messages.en || messages.fr || Object.values(messages)[0];
  }

  // ===== ACCROCHES PRODUIT CUREES (Arnaud 2026-06-04, source proactive_hooks_all_langs.json) =====
  // Map handle -> accroche par langue. Express perso ; non-Express + accessoires = generiques.
  var LS_HOOK_GENERIC = {
    non_express: {fr:"Un conseil sur la taille ? 🧵",de:"Brauchen Sie Hilfe bei der Größe? 🧵",it:"Un consiglio sulla taglia? 🧵",es:"¿Un consejo sobre la talla? 🧵",nl:"Advies over de maat? 🧵",en:"Need a size tip? 🧵",da:"Et råd om størrelsen? 🧵",sv:"Råd om storleken? 🧵",pl:"Porada w sprawie rozmiaru? 🧵"},
    patch: {fr:"Un patch pour personnaliser votre salopette 🔥",de:"Ein Patch für Ihre Latzhose 🔥",it:"Una patch per la tua salopette 🔥",es:"Un parche para tu peto 🔥",nl:"Een patch voor je tuinbroek 🔥",en:"A patch to make your dungarees yours 🔥",da:"En patch til dine smækbukser 🔥",sv:"Ett tygmärke till dina hängselbyxor 🔥",pl:"Naszywka, by spersonalizować Twoje ogrodniczki 🔥"},
    chaine: {fr:"La chaîne Plume, le détail qui change tout ✨",de:"Die Plume-Kette, das Detail, das alles macht ✨",it:"La catena Plume, il dettaglio che cambia tutto ✨",es:"La cadena Plume, el detalle que lo cambia todo ✨",nl:"De Plume-ketting, het detail dat alles maakt ✨",en:"The Plume chain, the detail that changes everything ✨",da:"Plume-kæden, detaljen der gør forskellen ✨",sv:"Plume-kedjan, detaljen som gör allt ✨",pl:"Łańcuszek Plume, detal, który robi różnicę ✨"}
  };
  var LS_HOOKS = {
    "la-salopette-origins": {fr:"La Salopette ORIGINS®, notre grand classique 💙",de:"Die ORIGINS® Latzhose, unser großer Klassiker 💙",it:"La Salopette ORIGINS®, il nostro grande classico 💙",es:"El Peto ORIGINS®, nuestro gran clásico 💙",nl:"De ORIGINS® Tuinbroek, onze grote klassieker 💙",en:"The ORIGINS® dungarees, our great classic 💙",da:"ORIGINS®-smækbukserne, vores store klassiker 💙",sv:"ORIGINS®-hängselbyxorna, vår stora klassiker 💙",pl:"Ogrodniczki ORIGINS®, nasz wielki klasyk 💙"},
    "salopette-jean-homme-bleu-ciel-classik": {fr:"La Classik®, le bleu ciel iconique 🩵",de:"Die Classik®, das ikonische Himmelblau 🩵",it:"La Classik®, l'azzurro cielo iconico 🩵",es:"El Classik®, el celeste icónico 🩵",nl:"De Classik®, het iconische hemelsblauw 🩵",en:"The Classik®, the iconic sky blue 🩵",da:"Classik®, den ikoniske himmelblå 🩵",sv:"Classik®, den ikoniska himmelsblå 🩵",pl:"Classik®, kultowy błękit nieba 🩵"},
    "salopette-jean-decontractee-mila": {fr:"La Mila et son pantalon regular à croquer 💙",de:"Die Mila, lässiger Regular-Schnitt zum Verlieben 💙",it:"La Mila e i suoi pantaloni regular irresistibili 💙",es:"La Mila y su pantalón regular irresistible 💙",nl:"De Mila met haar onweerstaanbare regular broek 💙",en:"The Mila and its adorable regular fit 💙",da:"Mila med dens uimodståelige regular pasform 💙",sv:"Mila med sin oemotståndliga regular-passform 💙",pl:"Mila i jej przepyszny regularny krój 💙"},
    "salopette-jean-extra-large-miko": {fr:"La Miko, l'oversize des 90's 🎤",de:"Die Miko, das Oversize der 90er 🎤",it:"La Miko, l'oversize anni '90 🎤",es:"La Miko, el oversize de los 90 🎤",nl:"De Miko, de oversize uit de 90's 🎤",en:"The Miko, the 90's oversize 🎤",da:"Miko, 90'ernes oversize 🎤",sv:"Miko, 90-talets oversize 🎤",pl:"Miko, oversize z lat 90. 🎤"},
    "salopette-coton-leopard-femme": {fr:"L'imprimé qui a du caractère 🐆",de:"Der Print mit Charakter 🐆",it:"La stampa con carattere 🐆",es:"El estampado con carácter 🐆",nl:"De print met karakter 🐆",en:"The print with character 🐆",da:"Printet med karakter 🐆",sv:"Trycket med karaktär 🐆",pl:"Print z charakterem 🐆"},
    "salopette-jean-large-jenny": {fr:"La Jenny®, le denim citadin 👖",de:"Die Jenny®, der urbane Denim 👖",it:"La Jenny®, il denim da città 👖",es:"La Jenny®, el denim urbano 👖",nl:"De Jenny®, het stadse denim 👖",en:"The Jenny®, the city denim 👖",da:"Jenny®, byens denim 👖",sv:"Jenny®, stadens denim 👖",pl:"Jenny®, miejski denim 👖"},
    "salopette-jean-carbone-brut": {fr:"Le denim noir brut, intemporel 🖤",de:"Roher schwarzer Denim, zeitlos 🖤",it:"Denim nero grezzo, senza tempo 🖤",es:"Denim negro crudo, atemporal 🖤",nl:"Ruw zwart denim, tijdloos 🖤",en:"Raw black denim, timeless 🖤",da:"Rå sort denim, tidløs 🖤",sv:"Rå svart denim, tidlös 🖤",pl:"Surowy czarny denim, ponadczasowy 🖤"},
    "salopette-denim-classique-marin": {fr:"La Pièce Marine par excellence ⚓️",de:"Das Marine-Stück schlechthin ⚓️",it:"Il capo marinaro per eccellenza ⚓️",es:"La prenda marinera por excelencia ⚓️",nl:"Hét marine-stuk bij uitstek ⚓️",en:"The marine piece par excellence ⚓️",da:"Det maritime stykke frem for alt ⚓️",sv:"Det marina plagget framför andra ⚓️",pl:"Marynarska klasyka w najlepszym wydaniu ⚓️"},
    "salopette-jean-american-vintage": {fr:"Le Jean délavé revient fort ! 🩵",de:"Der washed Denim kommt stark zurück! 🩵",it:"Il jeans slavato torna alla grande! 🩵",es:"¡El vaquero lavado vuelve con fuerza! 🩵",nl:"De washed denim is helemaal terug! 🩵",en:"Washed denim is back in force! 🩵",da:"Washed denim er tilbage for fuld styrke! 🩵",sv:"Tvättad denim är tillbaka på stort! 🩵",pl:"Sprany jeans wraca w wielkim stylu! 🩵"},
    "salopette-vintage-homme-willy": {fr:"Back to 90's ! 🩵",de:"Back to the 90's! 🩵",it:"Back to the 90's! 🩵",es:"¡Vuelta a los 90! 🩵",nl:"Back to the 90's! 🩵",en:"Back to the 90's! 🩵",da:"Tilbage til 90'erne! 🩵",sv:"Tillbaka till 90-talet! 🩵",pl:"Powrót do lat 90.! 🩵"},
    "salopette-vintage-jean-original": {fr:"Le jean originel 👖",de:"Der ursprüngliche Denim 👖",it:"Il jeans delle origini 👖",es:"El vaquero original 👖",nl:"De originele denim 👖",en:"The original denim 👖",da:"Den oprindelige denim 👖",sv:"Den ursprungliga denimen 👖",pl:"Jeans w pierwotnym wydaniu 👖"},
    "salopette-jean-bleue-homme-denim": {fr:"Le jean franc et robuste 💙",de:"Der ehrliche, robuste Denim 💙",it:"Il jeans schietto e robusto 💙",es:"El vaquero franco y resistente 💙",nl:"De eerlijke, stevige denim 💙",en:"The honest, sturdy denim 💙",da:"Den ærlige, robuste denim 💙",sv:"Den ärliga, robusta denimen 💙",pl:"Szczery i solidny jeans 💙"},
    "salopette-jean-bleue-homme-grizzy": {fr:"La Grizzy a du mordant ! 🧸",de:"Die Grizzy hat Biss! 🧸",it:"La Grizzy ha mordente! 🧸",es:"¡La Grizzy tiene garra! 🧸",nl:"De Grizzy heeft pit! 🧸",en:"The Grizzy has bite! 🧸",da:"Grizzy har bid! 🧸",sv:"Grizzy har bett! 🧸",pl:"Grizzy ma pazur! 🧸"},
    "salopette-jean-grande-taille-gaspard": {fr:"Taillée pour les grandes tailles (jusqu'au 5XL) 💙",de:"Gemacht für große Größen (bis 5XL) 💙",it:"Pensata per le taglie forti (fino alla 5XL) 💙",es:"Pensado para tallas grandes (hasta 5XL) 💙",nl:"Gemaakt voor grote maten (tot 5XL) 💙",en:"Made for big sizes (up to 5XL) 💙",da:"Skabt til store størrelser (op til 5XL) 💙",sv:"Gjord för stora storlekar (upp till 5XL) 💙",pl:"Skrojona dla dużych rozmiarów (aż do 5XL) 💙"},
    "salopette-jean-americaine-bricktown": {fr:"Denim américain esprit Brooklyn 🌆",de:"US-Denim im Brooklyn-Stil 🌆",it:"Denim americano spirito Brooklyn 🌆",es:"Denim americano espíritu Brooklyn 🌆",nl:"Amerikaans denim, Brooklyn-sfeer 🌆",en:"American denim, Brooklyn vibe 🌆",da:"Amerikansk denim, Brooklyn-stil 🌆",sv:"Amerikansk denim, Brooklyn-känsla 🌆",pl:"Amerykański denim w stylu Brooklynu 🌆"},
    "salopette-jean-militaire-us-army": {fr:"L'esprit militaire, pièce robuste 🫡",de:"Im Military-Look, robustes Stück 🫡",it:"Spirito militare, capo robusto 🫡",es:"Espíritu militar, prenda resistente 🫡",nl:"Militaire spirit, stevig stuk 🫡",en:"Military spirit, sturdy piece 🫡",da:"Militær ånd, robust stykke 🫡",sv:"Militärkänsla, robust plagg 🫡",pl:"Wojskowy duch, solidna sztuka 🫡"},
    "salopette-militaire-a-rayures-blanches": {fr:"L'allure rétro tic-tac 🕰️ (taille petite)",de:"Der Retro-Streifen-Look 🕰️ (fällt klein aus)",it:"Il look rétro tic-tac 🕰️ (veste piccolo)",es:"El look retro tic-tac 🕰️ (talla pequeña)",nl:"De retro tik-tak look 🕰️ (valt klein)",en:"The retro tick-tock look 🕰️ (runs small)",da:"Det retro tik-tak-look 🕰️ (lille i størrelsen)",sv:"Den retro tick-tack-looken 🕰️ (liten i storleken)",pl:"Styl retro tik-tak 🕰️ (mała rozmiarówka)"},
    "salopette-en-jean-style-urbain-ikigai": {fr:"La Pièce inspirée par Tokyo 🎎",de:"Das von Tokio inspirierte Stück 🎎",it:"Il capo ispirato a Tokyo 🎎",es:"La prenda inspirada en Tokio 🎎",nl:"Het door Tokio geïnspireerde stuk 🎎",en:"The Tokyo-inspired piece 🎎",da:"Det Tokyo-inspirerede stykke 🎎",sv:"Det Tokyo-inspirerade plagget 🎎",pl:"Sztuka inspirowana Tokio 🎎"},
    "salopette-vintage-cow-boy-union": {fr:"La Cow-Boy Union, l'esprit western 🤠",de:"Die Cow-Boy Union, Western-Feeling 🤠",it:"La Cow-Boy Union, spirito western 🤠",es:"La Cow-Boy Union, espíritu western 🤠",nl:"De Cow-Boy Union, westernsfeer 🤠",en:"The Cow-Boy Union, western spirit 🤠",da:"Cow-Boy Union, western-ånd 🤠",sv:"Cow-Boy Union, westernkänsla 🤠",pl:"Cow-Boy Union, duch westernu 🤠"},
    "salopette-coton-colorpack": {fr:"La Pièce tout en couleur 🌈",de:"Das Stück voller Farbe 🌈",it:"Il capo tutto colore 🌈",es:"La prenda llena de color 🌈",nl:"Het stuk vol kleur 🌈",en:"The piece full of colour 🌈",da:"Stykket fuld af farve 🌈",sv:"Plagget fullt av färg 🌈",pl:"Sztuka pełna koloru 🌈"},
    "salopette-datelier-homme": {fr:"Robuste et bien équipée 💪",de:"Robust und gut ausgestattet 💪",it:"Robusta e ben attrezzata 💪",es:"Resistente y bien equipado 💪",nl:"Stevig en goed uitgerust 💪",en:"Sturdy and well-equipped 💪",da:"Robust og veludstyret 💪",sv:"Robust och välutrustad 💪",pl:"Solidna i dobrze wyposażona 💪"},
    "salopette-de-travail-de-bucheron": {fr:"La Pièce robuste, poche bib zippée 🪵",de:"Das robuste Stück, Latztasche mit Reißverschluss 🪵",it:"Il capo robusto, tasca bib con zip 🪵",es:"La prenda robusta, bolsillo bib con cremallera 🪵",nl:"Het stevige stuk, borstzak met rits 🪵",en:"The sturdy piece, zipped bib pocket 🪵",da:"Det robuste stykke, smæklomme med lynlås 🪵",sv:"Det robusta plagget, bröstficka med dragkedja 🪵",pl:"Solidna sztuka, zapinana kieszeń na napierśniku 🪵"},
    "salopette-de-chantier-noire": {fr:"La Chantier, noire et zippée 🖤",de:"Die Chantier, schwarz und mit Reißverschluss 🖤",it:"La Chantier, nera e con zip 🖤",es:"La Chantier, negra y con cremallera 🖤",nl:"De Chantier, zwart en met rits 🖤",en:"The Chantier, black and zipped 🖤",da:"Chantier, sort og med lynlås 🖤",sv:"Chantier, svart och med dragkedja 🖤",pl:"Chantier: czarna, z zamkami 🖤"},
    "salopette-jean-de-menuisier": {fr:"Le denim noir taillé pour l'établi 🪵",de:"Schwarzer Denim für die Werkbank 🪵",it:"Il denim nero fatto per il banco 🪵",es:"El denim negro hecho para el banco 🪵",nl:"Zwart denim gemaakt voor de werkbank 🪵",en:"Black denim built for the bench 🪵",da:"Sort denim skabt til høvlebænken 🪵",sv:"Svart denim gjord för hyvelbänken 🪵",pl:"Czarny denim stworzony do warsztatu 🪵"},
    "salopette-de-travail-cotte-de-marin": {fr:"Une Question sur la cotte de Marin ? ⚓️",de:"Eine Frage zur Cotte de Marin? ⚓️",it:"Una domanda sulla Cotte de Marin? ⚓️",es:"¿Una pregunta sobre la Cotte de Marin? ⚓️",nl:"Een vraag over de Cotte de Marin? ⚓️",en:"A question about the Cotte de Marin? ⚓️",da:"Et spørgsmål om Cotte de Marin? ⚓️",sv:"En fråga om Cotte de Marin? ⚓️",pl:"Pytanie o ogrodniczki Marin? ⚓️"},
    "salopette-de-pecheur": {fr:"L'esprit marin, jean costaud 🎣",de:"Maritimes Feeling, robuster Denim 🎣",it:"Spirito marinaro, denim resistente 🎣",es:"Espíritu marinero, vaquero resistente 🎣",nl:"Maritieme sfeer, stevig denim 🎣",en:"Sailor spirit, tough denim 🎣",da:"Sømandsånd, robust denim 🎣",sv:"Sjömanskänsla, tålig denim 🎣",pl:"Marynarski duch, mocny jeans 🎣"},
    "salopette-de-travail-marron-forestiere": {fr:"Salopette Forestière, une toile robuste 🪵",de:"Latzhose Forestière, robustes Gewebe 🪵",it:"Salopette Forestière, tela robusta 🪵",es:"Peto Forestière, lona resistente 🪵",nl:"Tuinbroek Forestière, stevige stof 🪵",en:"Forestière dungarees, sturdy canvas 🪵",da:"Forestière smækbukser, robust lærred 🪵",sv:"Forestière hängselbyxor, robust väv 🪵",pl:"Ogrodniczki Forestière, wytrzymałe płótno 🪵"},
    "salopette-vintage-verte-sapin-yko": {fr:"La Velours verte Sapin, un conseil ? 🌲",de:"In Tannengrün, ein Tipp? 🌲",it:"Il velluto verde abete, un consiglio? 🌲",es:"La pana verde abeto, ¿un consejo? 🌲",nl:"Het dennengroene ribfluweel, advies? 🌲",en:"The fir-green corduroy, a tip? 🌲",da:"Den grangrønne fløjl, et råd? 🌲",sv:"Den grangröna manchestern, ett råd? 🌲",pl:"Zielony sztruks Sapin, jakieś pytanie? 🌲"},
    "salopette-short-grande-taille-azur": {fr:"La version Bermuda pour l'été ☀️",de:"Die Bermuda-Version für den Sommer ☀️",it:"La versione Bermuda per l'estate ☀️",es:"La versión Bermuda para el verano ☀️",nl:"De Bermuda-versie voor de zomer ☀️",en:"The Bermuda version for summer ☀️",da:"Bermuda-versionen til sommeren ☀️",sv:"Bermuda-versionen för sommaren ☀️",pl:"Wersja bermudy na lato ☀️"},
    "salopette-de-travail-browning-traqueur": {fr:"La Browning Traqueur, esprit grand air 🌳",de:"Die Browning Traqueur, Outdoor-Spirit 🌳",it:"La Browning Traqueur, spirito outdoor 🌳",es:"La Browning Traqueur, espíritu aire libre 🌳",nl:"De Browning Traqueur, buitensfeer 🌳",en:"The Browning Traqueur, outdoor spirit 🌳",da:"Browning Traqueur, frilufts-ånd 🌳",sv:"Browning Traqueur, frilufts-känsla 🌳",pl:"Browning Traqueur, duch wielkiej przygody 🌳"},
    "salopette-jean-streetwear-vantablack": {fr:"Noir c'est noir 🖤 Un doute sur la taille ?",de:"Schwarz ist Schwarz 🖤 Unsicher bei der Größe?",it:"Nero è nero 🖤 Dubbi sulla taglia?",es:"Negro es negro 🖤 ¿Dudas con la talla?",nl:"Zwart is zwart 🖤 Twijfel over de maat?",en:"Black is black 🖤 Unsure about the size?",da:"Sort er sort 🖤 I tvivl om størrelsen?",sv:"Svart är svart 🖤 Osäker på storleken?",pl:"Czarne jak noc 🖤 Wątpliwości co do rozmiaru?"},
    "salopette-jean-la-peintre": {fr:"La Salopette de l'Artiste 🎨",de:"Die Latzhose des Künstlers 🎨",it:"La Salopette dell'Artista 🎨",es:"El Peto del Artista 🎨",nl:"De Tuinbroek van de Kunstenaar 🎨",en:"The Artist's dungarees 🎨",da:"Kunstnerens smækbukser 🎨",sv:"Konstnärens hängselbyxor 🎨",pl:"Ogrodniczki Artysty 🎨"},
    "salopette-velours-cotele-burgundy": {fr:"La Burgundy, velours côtelé bordeaux 🍷",de:"Die Burgundy, Kord in Bordeaux 🍷",it:"La Burgundy, velluto a coste bordeaux 🍷",es:"La Burgundy, pana burdeos 🍷",nl:"De Burgundy, bordeaux ribfluweel 🍷",en:"The Burgundy, burgundy corduroy 🍷",da:"Burgundy, bordeaux fløjl 🍷",sv:"Burgundy, vinröd manchester 🍷",pl:"Burgundy, bordowy sztruks 🍷"},
    "salopette-velours-cotele-coconut": {fr:"La Coconut®, velours et douceur 🥥",de:"Die Coconut®, Kord und Sanftheit 🥥",it:"La Coconut®, velluto e dolcezza 🥥",es:"La Coconut®, pana y suavidad 🥥",nl:"De Coconut®, ribfluweel en zachtheid 🥥",en:"The Coconut®, corduroy and softness 🥥",da:"Coconut®, fløjl og blødhed 🥥",sv:"Coconut®, manchester och mjukhet 🥥",pl:"Coconut®, sztruks i miękkość 🥥"},
    "salopette-velours-cotele-opalin": {fr:"La Opalin, velours clair et lumineux 🤍",de:"Die Opalin, heller, leuchtender Kord 🤍",it:"La Opalin, velluto chiaro e luminoso 🤍",es:"La Opalin, pana clara y luminosa 🤍",nl:"De Opalin, licht en helder ribfluweel 🤍",en:"The Opalin, light and luminous corduroy 🤍",da:"Opalin, lys og lysende fløjl 🤍",sv:"Opalin, ljus och lysande manchester 🤍",pl:"Opalin, jasny i świetlisty sztruks 🤍"},
    "salopette-velours-marron-peanut": {fr:"La Peanut®, velours noisette 🌰",de:"Die Peanut®, nussbrauner Samt 🌰",it:"La Peanut®, velluto nocciola 🌰",es:"La Peanut®, terciopelo avellana 🌰",nl:"De Peanut®, hazelnootbruin fluweel 🌰",en:"The Peanut®, hazelnut velvet 🌰",da:"Peanut®, hasselnød-fløjl 🌰",sv:"Peanut®, hasselnötsfärgad sammet 🌰",pl:"Peanut®, orzechowy sztruks 🌰"},
    "salopette-velours-grise-homme-argile": {fr:"L'Argile, velours 320 gsm 🩶",de:"Die Argile, Samt 320 g/m² 🩶",it:"L'Argile, velluto 320 g/m² 🩶",es:"El Argile, terciopelo 320 g/m² 🩶",nl:"De Argile, fluweel 320 g/m² 🩶",en:"The Argile, 320 gsm velvet 🩶",da:"Argile, 320 g/m² fløjl 🩶",sv:"Argile, 320 g/m² sammet 🩶",pl:"Argile, sztruks 320 gsm 🩶"},
    "salopette-velours-marron-terracotta": {fr:"La Terracotta, le velours d'automne 🍂",de:"Die Terracotta, der Herbst-Samt 🍂",it:"La Terracotta, il velluto d'autunno 🍂",es:"La Terracotta, el terciopelo de otoño 🍂",nl:"De Terracotta, het herfstfluweel 🍂",en:"The Terracotta, autumn velvet 🍂",da:"Terracotta, efterårets fløjl 🍂",sv:"Terracotta, höstens sammet 🍂",pl:"Terracotta, jesienny sztruks 🍂"},
    "salopette-velours-cotele-cloud": {fr:"La Cloud, velours côtelé tout doux ☁️",de:"Die Cloud, ganz weicher Kord ☁️",it:"La Cloud, velluto a coste morbidissimo ☁️",es:"La Cloud, pana muy suave ☁️",nl:"De Cloud, heel zacht ribfluweel ☁️",en:"The Cloud, super-soft corduroy ☁️",da:"Cloud, supersblød fløjl ☁️",sv:"Cloud, supermjuk manchester ☁️",pl:"Cloud, mięciutki sztruks ☁️"},
    "salopette-velours-homme-pearl": {fr:"La Pearl, velours homme nacré...",de:"Die Pearl, perlmuttfarbener Herren-Samt...",it:"La Pearl, velluto uomo perlato...",es:"La Pearl, terciopelo hombre nacarado...",nl:"De Pearl, parelmoer herenfluweel...",en:"The Pearl, pearly men's velvet...",da:"Pearl, perlemorsfarvet herrefløjl...",sv:"Pearl, pärlemorsskimrande herrsammet...",pl:"Pearl, perłowy męski sztruks..."},
    "salopette-velours-cotele-ivory": {fr:"L'Ivory®, l'art de porter le noir 🖤",de:"Die Ivory®, die Kunst, Schwarz zu tragen 🖤",it:"La Ivory®, l'arte di vestire il nero 🖤",es:"El Ivory®, el arte de vestir de negro 🖤",nl:"De Ivory®, de kunst om zwart te dragen 🖤",en:"The Ivory®, the art of wearing black 🖤",da:"Ivory®, kunsten at bære sort 🖤",sv:"Ivory®, konsten att bära svart 🖤",pl:"Ivory®, sztuka noszenia czerni 🖤"},
    "salopette-velours-cotele-alpaga": {fr:"L'Alpaga®, cintrée et bien taillée 🦙",de:"Die Alpaga®, tailliert und gut geschnitten 🦙",it:"L'Alpaga®, sciancrata e ben tagliata 🦙",es:"El Alpaga®, entallado y bien cortado 🦙",nl:"De Alpaga®, getailleerd en goed gesneden 🦙",en:"The Alpaga®, fitted and well-cut 🦙",da:"Alpaga®, taljeret og velskåret 🦙",sv:"Alpaga®, figursydd och välskuren 🦙",pl:"Alpaga®, dopasowana i świetnie skrojona 🦙"},
    "salopette-velours-cotele-grenat": {fr:"La Grenat, le velours rouge profond 🍒",de:"Die Grenat, tiefroter Kord 🍒",it:"La Grenat, velluto rosso profondo 🍒",es:"La Grenat, pana rojo profundo 🍒",nl:"De Grenat, dieprood ribfluweel 🍒",en:"The Grenat, deep red corduroy 🍒",da:"Grenat, dybrød fløjl 🍒",sv:"Grenat, djupröd manchester 🍒",pl:"Grenat, sztruks w głębokiej czerwieni 🍒"},
    "salopette-vintage-velours-cotele-alezan": {fr:"L'Alezan, son velours châtaigne 🌰",de:"Die Alezan, ihr kastanienbrauner Kord 🌰",it:"L'Alezan, il suo velluto castagna 🌰",es:"El Alezan, su pana castaño 🌰",nl:"De Alezan, haar kastanjebruin ribfluweel 🌰",en:"The Alezan, its chestnut corduroy 🌰",da:"Alezan, dens kastaniebrune fløjl 🌰",sv:"Alezan, dess kastanjebruna manchester 🌰",pl:"Alezan, kasztanowy sztruks 🌰"},
    "salopette-vintage-velours-cotele-taupe": {fr:"La Taupe, la pièce du coin du feu 🕰️",de:"Die Taupe, das Stück fürs Kaminfeuer 🕰️",it:"La Taupe, il capo dell'angolo del camino 🕰️",es:"La Taupe, la prenda junto al fuego 🕰️",nl:"De Taupe, het stuk bij de open haard 🕰️",en:"The Taupe, the fireside piece 🕰️",da:"Taupe, stykket ved pejsen 🕰️",sv:"Taupe, plagget vid brasan 🕰️",pl:"Taupe, sztuka na wieczory przy kominku 🕰️"},
    "salopette-vintage-velours-vert": {fr:"La Vintage velours vert, une question ? 🌿",de:"Die Vintage in grünem Samt, eine Frage? 🌿",it:"La Vintage in velluto verde, una domanda? 🌿",es:"La Vintage en terciopelo verde, ¿una pregunta? 🌿",nl:"De Vintage in groen fluweel, een vraag? 🌿",en:"The vintage green velvet, a question? 🌿",da:"Den vintage grønne fløjl, et spørgsmål? 🌿",sv:"Den vintage gröna sammeten, en fråga? 🌿",pl:"Vintage w zielonym sztruksie, jakieś pytanie? 🌿"},
    "salopette-vintage-velours-violette": {fr:"La Violette, le velours qui ose 💜",de:"Die Violette, der mutige Samt 💜",it:"La Violette, il velluto che osa 💜",es:"La Violette, el terciopelo que se atreve 💜",nl:"De Violette, het fluweel dat durft 💜",en:"The Violette, the velvet that dares 💜",da:"Violette, fløjlen der tør 💜",sv:"Violette, sammeten som vågar 💜",pl:"Violette, sztruks, który ma odwagę 💜"},
    "salopette-vintage-noire-velours-cotele": {fr:"Le velours côtelé noir, valeur sûre 🖤",de:"Schwarzer Kord, sichere Wahl 🖤",it:"Velluto a coste nero, valore sicuro 🖤",es:"Pana negra, valor seguro 🖤",nl:"Zwart ribfluweel, zekere waarde 🖤",en:"Black corduroy, a safe bet 🖤",da:"Sort fløjl, et sikkert valg 🖤",sv:"Svart manchester, ett säkert val 🖤",pl:"Czarny sztruks, pewny wybór 🖤"},
    "salopette-vintage-velours-noir": {fr:"La Vintage velours noir, allure rétro 🖤",de:"Die Vintage in schwarzem Samt, Retro-Look 🖤",it:"La Vintage in velluto nero, look rétro 🖤",es:"La Vintage en terciopelo negro, aire retro 🖤",nl:"De Vintage in zwart fluweel, retro look 🖤",en:"The vintage black velvet, retro look 🖤",da:"Den vintage sorte fløjl, retro-look 🖤",sv:"Den vintage svarta sammeten, retro-look 🖤",pl:"Vintage w czarnym sztruksie, retro styl 🖤"}
  };

    // ===== HOOK PRODUIT PERSONNALISE (Arnaud 2026-06-01) =====
  // Bulle proactive fiche produit : compliment personnalisé selon LE produit + nudge taille,
  // multilingue. Le compliment est choisi de façon DETERMINISTE par nom (même produit = même
  // compliment = personnalité stable, produits différents = compliments variés).
  var HOOK_I18N = {
    compliments: {
      fr: ["très bon choix 👍", "une valeur sûre 🖤", "excellent choix ✨", "un vrai coup de cœur 💚"],
      de: ["sehr gute Wahl 👍", "ein sicherer Wert 🖤", "ausgezeichnete Wahl ✨", "ein echter Liebling 💚"],
      it: ["ottima scelta 👍", "una certezza 🖤", "scelta eccellente ✨", "un vero amore 💚"],
      es: ["muy buena elección 👍", "una apuesta segura 🖤", "excelente elección ✨", "todo un flechazo 💚"],
      nl: ["heel goede keuze 👍", "een zekere waarde 🖤", "uitstekende keuze ✨", "een echte favoriet 💚"],
      en: ["great choice 👍", "a safe bet 🖤", "excellent choice ✨", "a real favourite 💚"],
      da: ["rigtig godt valg 👍", "et sikkert valg 🖤", "fremragende valg ✨", "en sand favorit 💚"],
      sv: ["riktigt bra val 👍", "ett säkert kort 🖤", "utmärkt val ✨", "en riktig favorit 💚"],
      pt: ["ótima escolha 👍", "uma aposta segura 🖤", "excelente escolha ✨", "um verdadeiro amor 💚"],
      pl: ["bardzo dobry wybór 👍", "pewny wybór 🖤", "doskonały wybór ✨", "prawdziwy faworyt 💚"],
      ru: ["отличный выбор 👍", "беспроигрышный вариант 🖤", "превосходный выбор ✨", "настоящий фаворит 💚"],
      ja: ["とても良い選択です 👍", "間違いない一着です 🖤", "素晴らしい選択です ✨", "イチオシです 💚"],
      ko: ["아주 좋은 선택이에요 👍", "믿고 사는 제품이에요 🖤", "훌륭한 선택이에요 ✨", "강력 추천이에요 💚"],
      zh: ["很棒的选择 👍", "稳妥之选 🖤", "绝佳选择 ✨", "真心推荐 💚"],
      hr: ["odličan izbor 👍", "siguran izbor 🖤", "izvrstan izbor ✨", "pravi favorit 💚"]
    },
    size: {
      fr: "Je vous aide pour la taille ?", de: "Brauchen Sie Hilfe bei der Größe ?", it: "Ti aiuto con la taglia ?",
      es: "¿Te ayudo con la talla?", nl: "Hulp nodig bij de maat ?", en: "Need help with the size ?",
      da: "Brug for hjælp til størrelsen ?", sv: "Behöver du hjälp med storleken ?", pt: "Precisa de ajuda com o tamanho ?",
      pl: "Pomóc z rozmiarem ?", ru: "Помочь с размером ?", ja: "サイズのご相談はいかがですか？",
      ko: "사이즈 도와드릴까요?", zh: "需要帮您选尺码吗？", hr: "Trebate pomoć s veličinom ?"
    }
  };
  function _hashIdx(str, mod) {
    var h = 0; for (var i = 0; i < str.length; i++) { h = (h * 31 + str.charCodeAt(i)) >>> 0; }
    return mod ? (h % mod) : h;
  }
  function getProductName() {
    try {
      if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.title) {
        return String(ShopifyAnalytics.meta.product.title).trim();
      }
    } catch (e) {}
    try {
      var og = document.querySelector('meta[property="og:title"]');
      if (og && og.content && og.content.trim()) return og.content.split("|")[0].trim();
    } catch (e) {}
    var h1 = document.querySelector("h1");
    if (h1 && (h1.textContent || "").trim()) return h1.textContent.trim();
    return (document.title || "").split("|")[0].split("–")[0].trim();
  }
  function getProductId() {
    // ID produit NUMERIQUE = identique sur TOUS les marchés (le handle d'URL est localisé sur
    // les marchés non-FR et non résolu côté admin). Plusieurs sources selon le thème.
    try { if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.id) return String(ShopifyAnalytics.meta.product.id); } catch (e) {}
    try { if (window.meta && window.meta.product && window.meta.product.id) return String(window.meta.product.id); } catch (e) {}
    try { if (window.__st && window.__st.rid) return String(window.__st.rid); } catch (e) {}
    return "";
  }
  // Emoji assorti a la COULEUR du produit (Arnaud 2026-06-02 : la Carbon® est noire -> 🖤, pas 💚).
  // Ordre : le plus specifique d'abord (carbon/brut/noir avant jean/denim qui sont bleus par defaut).
  function _colorEmoji(name) {
    var n = (name || "").toLowerCase();
    if (/\b(noir(?:e|es|s)?|black|negro|nero|schwarz|zwart|carbon|carbone|brut|vantablack|charbon|coal|onyx|anthracite)\b/.test(n)) return "🖤";
    if (/\b(blanc(?:he|hes|s)?|white|blanco|bianco|weiss|wit(?:te)?|ivoire|ivory|cloud|opalin|cru)\b/.test(n)) return "🤍";
    if (/\b(rouge|red|rojo|rosso|rot|rood|grenat|garnet|burgundy|bordeaux|carmin|vin|wine)\b/.test(n)) return "❤️";
    if (/\b(marron|brown|marr[oó]n|braun|bruin|terracotta|peanut|chataigne|ch[aâ]taigne|cognac|camel|rust|caramel|chocolat|moka)\b/.test(n)) return "🤎";
    if (/\b(vert(?:e|es|s)?|green|verde|gr[uü]n|groen|kaki|khaki|olive|sauge|sage)\b/.test(n)) return "💚";
    if (/\b(gris(?:e|es)?|grey|gray|grigio|grau|grijs|argile|pearl|perle|ardoise|slate)\b/.test(n)) return "🩶";
    if (/\b(jaune|yellow|amarillo|giallo|gelb|geel|moutarde|mustard|ocre)\b/.test(n)) return "💛";
    if (/\b(rose|pink|rosa|roze|fuchsia|fush)\b/.test(n)) return "🩷";
    if (/\b(violet|purple|morado|viola|lila|paars|lavande|mauve)\b/.test(n)) return "💜";
    if (/\b(bleu(?:e|es|s)?|blue|azul|blu|blau|blauw|denim|jean|ciel|celeste|c[eé]leste|marin|marine|navy|cobalt|indigo|origins)\b/.test(n)) return "💙";
    return null; // pas de couleur claire -> on garde l'emoji du compliment
  }
  // Map ID produit (numerique, STABLE tous marches) -> handle FR, pour resoudre les accroches sur les
  // marches non-FR (handle d'URL localise). Arnaud 2026-06-05 : accroches DE non traduites.
  var LS_ID2HANDLE = {"15904545472856": "salopette-jean-de-menuisier", "10099307446616": "la-salopette-origins", "5769496395944": "salopette-jean-homme-bleu-ciel-classik", "9174688629080": "salopette-jean-decontractee-mila", "9171179995480": "salopette-jean-extra-large-miko", "15187829096792": "salopette-coton-leopard-femme", "14688696992088": "salopette-jean-large-jenny", "8114983960832": "salopette-jean-carbone-brut", "5723693514920": "salopette-denim-classique-marin", "15184784720216": "salopette-jean-american-vintage", "15191038853464": "salopette-vintage-homme-willy", "14688823869784": "salopette-vintage-jean-original", "5769524904104": "salopette-jean-bleue-homme-denim", "5768169128104": "salopette-jean-bleue-homme-grizzy", "15191218323800": "salopette-jean-grande-taille-gaspard", "7472190554368": "salopette-jean-americaine-bricktown", "7959149641984": "salopette-jean-militaire-us-army", "15080978776408": "salopette-militaire-a-rayures-blanches", "5744455647400": "salopette-en-jean-style-urbain-ikigai", "5744182722728": "salopette-vintage-cow-boy-union", "15185393320280": "salopette-coton-colorpack", "15656318402904": "salopette-datelier-homme", "8625972609368": "salopette-de-travail-de-bucheron", "9188439294296": "salopette-de-chantier-noire", "7469726269696": "salopette-de-travail-cotte-de-marin", "15665118183768": "salopette-de-pecheur", "6151712506024": "salopette-de-travail-marron-forestiere", "5744174792872": "salopette-vintage-verte-sapin-yko", "9177625362776": "salopette-short-grande-taille-azur", "5769695559848": "salopette-de-travail-browning-traqueur", "15183491727704": "salopette-jean-streetwear-vantablack", "15750498124120": "salopette-jean-la-peintre", "15187184648536": "salopette-velours-cotele-burgundy", "14690777432408": "salopette-velours-cotele-coconut", "15189295169880": "salopette-velours-cotele-opalin", "15192899486040": "salopette-velours-marron-peanut", "15193011585368": "salopette-velours-grise-homme-argile", "15189776859480": "salopette-velours-marron-terracotta", "15189972844888": "salopette-velours-cotele-cloud", "15192371298648": "salopette-velours-homme-pearl", "14691850486104": "salopette-velours-cotele-ivory", "14691521757528": "salopette-velours-cotele-alpaga", "15191484137816": "salopette-velours-cotele-grenat", "7730535530752": "salopette-vintage-velours-cotele-alezan", "7730535694592": "salopette-vintage-velours-cotele-taupe", "8654689730904": "salopette-vintage-velours-vert", "8654514848088": "salopette-vintage-velours-violette", "7730535792896": "salopette-vintage-noire-velours-cotele", "8654637924696": "salopette-vintage-velours-noir"};

    // Accroche par HANDLE (Arnaud 2026-06-04) : Express perso (LS_HOOKS) ; patchs/chaine = generique
  // accessoire ; produit non liste (non-Express ou inconnu) = generique non-Express. Fallback locale->en->fr.
  function productHookText(handle, locale) {
    var h = (handle || "").toLowerCase();
    function pick(m) { return (m && (m[locale] || m.en || m.fr)) || ""; }
    // 🇩🇪 Non-FR : le handle d'URL est localise (ex DE latzhose-jeans-streetwear-vantablack) et n'est PAS
    // dans LS_HOOKS (keye FR). On resout via l'ID produit (numerique, identique tous marches) -> handle FR.
    if (!LS_HOOKS[h]) {
      try { var pid = getProductId(); if (pid && LS_ID2HANDLE[pid]) h = LS_ID2HANDLE[pid]; } catch (e) {}
    }
    if (/patch|thermocollant|sticker/.test(h)) return pick(LS_HOOK_GENERIC.patch);
    if (/chaine|cha[iî]ne|plume/.test(h)) return pick(LS_HOOK_GENERIC.chaine);
    if (LS_HOOKS[h]) return pick(LS_HOOKS[h]);
    return pick(LS_HOOK_GENERIC.non_express);
  }

  function fireProactiveTrigger() {
    // 🔕 Pas de bulle proactive si le client a DEJA interagi (Arnaud 2026-06-05 : inutile de re-balancer
    // l'accroche a quelqu'un qui nous a deja parle). Si la conversation contient un message visiteur, on
    // n'ouvre aucune bulle (welcome ni produit). Le cooldown localStorage gere deja le 1x/24h par client.
    try { if (state.messages && state.messages.some(function (m) { return m.role === "user"; })) return; } catch (e) {}
    // SEQUENCE (Arnaud 2026-06-01) :
    //  - 10s apres la 1ere visite (toute page hors pages a CTA specifique) : message d'accueil "welcome"
    //  - sur une FICHE PRODUIT : +2 min => aide a choisir la taille "product_sizing" (si toujours la + chat ferme)
    //  - pages specifiques (guide tailles = champ saisie, express, retour, contact) : leur trigger dedie
    var path = window.location.pathname || "/";
    var locale = detectLocale();
    var cooldownKey = "ls_proactive_seen";
    var seen = {};
    try { seen = JSON.parse(localStorage.getItem(cooldownKey) || "{}"); } catch (e) {}
    var now = Date.now();
    var DAY_MS = 24 * 3600 * 1000;

    function notSeen(name) { return !(seen[name] && (now - seen[name]) < DAY_MS); }
    function byName(name) {
      for (var i = 0; i < PROACTIVE_TRIGGERS.length; i++) if (PROACTIVE_TRIGGERS[i].name === name) return PROACTIVE_TRIGGERS[i];
      return null;
    }
    function fire(trigger, delay) {
      if (!trigger || !notSeen(trigger.name)) return;
      setTimeout(function () {
        if (state.open) return; // chat deja ouvert -> on n'embete pas
        if (lsShouldHide()) return; // panier/checkout/drawer ouvert -> pas de bulle
        var msg = pickMessage(trigger.messages, locale);
        if (!msg) return;
        msg = msg.replace("{d}", EXP_DELAY).replace("{f}", EXP_FLAG); // Express : delai+drapeau selon le pays (Arnaud 2026-06-25)
        showProactiveBubble(trigger, msg); // remplace toute bulle precedente
        seen[trigger.name] = Date.now();
        try { localStorage.setItem(cooldownKey, JSON.stringify(seen)); } catch (e) {}
      }, delay);
    }

    // Pages a CTA specifique (prioritaires sur le welcome generique)
    var specifics = ["size_guide", "express_collection", "return_policy", "contact_page"];
    var matched = null;
    for (var i = 0; i < specifics.length; i++) {
      var t = byName(specifics[i]);
      if (t && t.url_re.test(path)) { matched = t; break; }
    }

    var _isProduct = /\/products\//i.test(path);
    if (matched) {
      fire(matched, matched.delay_ms);
    } else if (!_isProduct) {
      fire(byName("welcome"), 10000); // 10s : accueil (PAS sur une fiche produit -> l'accroche perso prend la place)
    }

    // FICHE PRODUIT : accroche PERSONNALISEE selon le produit (Arnaud 2026-06-04 : 80s etait trop long,
    // on ne la voyait jamais -> 22s). Cooldown PAR PRODUIT (chaque fiche montre SON accroche 1x/24h, pas
    // un cooldown global qui bloque tout). Encart "Une question ?", seed:true (accroche = 1er message bot).
    var _ph = _isProduct ? (path.match(/\/products\/([^/?#]+)/) || [])[1] : "";
    var _phCool = "product_hook:" + (_ph || "");
    if (_ph && notSeen(_phCool)) {
      setTimeout(function () {
        if (state.open) return;
        if (lsShouldHide()) return; // panier/checkout/drawer ouvert -> pas de bulle produit
        var text = productHookText(_ph, locale);
        if (!text) return;
        showProactiveBubble({ name: "product_hook", cta: "input", placeholder_key: "ph_q", seed: true }, text);
        seen[_phCool] = Date.now();
        try { localStorage.setItem(cooldownKey, JSON.stringify(seen)); } catch (e) {}
      }, 12000);
    }
  }

  // Libellés localisés des CTA proactifs (Bloc 2, Arnaud 2026-06-01)
  var PROACTIVE_I18N = {
    yes:   { fr: "Oui !", de: "Ja, gerne !", it: "Sì !", es: "¡Sí !", nl: "Ja !", en: "Yes !", da: "Ja !", sv: "Ja !", pt: "Sim !", pl: "Tak !", ru: "Да !", ja: "はい！", ko: "네 !", zh: "好的！", hr: "Da !" },
    later: { fr: "Plus tard...", de: "Später...", it: "Più tardi...", es: "Más tarde...", nl: "Later...", en: "Later...", da: "Senere...", sv: "Senare...", pt: "Mais tarde...", pl: "Później...", ru: "Позже...", ja: "あとで...", ko: "나중에...", zh: "稍后...", hr: "Kasnije..." },
    ph:    { fr: "Votre taille, poids, modèle...", de: "Größe, Gewicht, Modell...", it: "Altezza, peso, modello...", es: "Altura, peso, modelo...", nl: "Lengte, gewicht, model...", en: "Height, weight, model...", da: "Højde, vægt, model...", sv: "Längd, vikt, modell...", pt: "Altura, peso, modelo...", pl: "Wzrost, waga, model...", ru: "Рост, вес, модель...", ja: "身長・体重・モデル...", ko: "키, 몸무게, 모델...", zh: "身高、体重、款式...", hr: "Visina, težina, model..." },
    send:  { fr: "Envoyer", de: "Senden", it: "Invia", es: "Enviar", nl: "Versturen", en: "Send", da: "Send", sv: "Skicka", pt: "Enviar", pl: "Wyślij", ru: "Отправить", ja: "送信", ko: "보내기", zh: "发送", hr: "Pošalji" },
    ph_q:  { fr: "Une question ?", de: "Eine Frage ?", it: "Una domanda ?", es: "¿Una pregunta?", nl: "Een vraag ?", en: "A question ?", da: "Et spørgsmål ?", sv: "En fråga ?", pt: "Uma pergunta ?", pl: "Pytanie ?", ru: "Вопрос ?", ja: "ご質問は？", ko: "궁금한 점 있으세요?", zh: "有问题吗？", hr: "Pitanje ?" },
    sizehelp: { fr: "Je veux de l'aide pour choisir ma taille sur ce modèle", de: "Ich möchte Hilfe bei der Größenwahl für dieses Modell", it: "Vorrei aiuto per scegliere la taglia di questo modello", es: "Quiero ayuda para elegir mi talla en este modelo", nl: "Ik wil hulp bij het kiezen van mijn maat voor dit model", en: "I'd like help choosing my size for this model", da: "Jeg vil gerne have hjælp til at vælge min størrelse til denne model", sv: "Jag vill ha hjälp att välja storlek för den här modellen", pt: "Quero ajuda para escolher o meu tamanho neste modelo", pl: "Chcę pomocy w doborze rozmiaru tego modelu", ru: "Помогите выбрать размер для этой модели", ja: "このモデルのサイズ選びを手伝ってほしいです", ko: "이 모델의 사이즈 선택을 도와주세요", zh: "我想要这款的尺码建议", hr: "Želim pomoć pri odabiru veličine za ovaj model" },
    chip_size:   { fr: "Taille 🧵", de: "Größe 🧵", it: "Taglia 🧵", es: "Talla 🧵", nl: "Maat 🧵", en: "Size 🧵", da: "Størrelse 🧵", sv: "Storlek 🧵", pt: "Tamanho 🧵", pl: "Rozmiar 🧵", ru: "Размер 🧵", ja: "サイズ 🧵", ko: "사이즈 🧵", zh: "尺码 🧵", hr: "Veličina 🧵" },
    chip_promo:  { fr: "Code Promo 🔖", de: "Rabattcode 🔖", it: "Codice sconto 🔖", es: "Código promo 🔖", nl: "Kortingscode 🔖", en: "Promo code 🔖", da: "Rabatkode 🔖", sv: "Rabattkod 🔖", pt: "Código promo 🔖", pl: "Kod rabatowy 🔖", ru: "Промокод 🔖", ja: "プロモコード 🔖", ko: "프로모 코드 🔖", zh: "优惠码 🔖", hr: "Promo kod 🔖" },
    chip_return: { fr: "Retour / Échange", de: "Rückgabe / Umtausch", it: "Reso / Cambio", es: "Devolución / Cambio", nl: "Retour / Ruil", en: "Return / Exchange", da: "Retur / Bytte", sv: "Retur / Byte", pt: "Devolução / Troca", pl: "Zwrot / Wymiana", ru: "Возврат / Обмен", ja: "返品 / 交換", ko: "반품 / 교환", zh: "退货 / 换货", hr: "Povrat / Zamjena" }
  };
  function pi18n(key, locale) { var m = PROACTIVE_I18N[key] || {}; return m[locale] || m.en || m.fr; }

  function showProactiveBubble(trigger, text) {
    var existing = document.getElementById("ls-proactive-bubble");
    if (existing) existing.remove();
    var fabRoot = document.getElementById("ls-chat-root");
    if (!fabRoot) return;
    // Mémorise le message proactif pour l'injecter dans le chat à l'ouverture
    state.pendingProactive = text;
    var locale = detectLocale();
    var cta = (trigger && trigger.cta) || "chips";
    var controlsEl;

    if (cta === "input") {
      // Guide des tailles : le client écrit ses mensurations DANS la bulle, sans ouvrir le chat.
      // product_hook (seed:true, Arnaud 2026-06-04) : on GARDE l'accroche -> elle s'affiche comme 1er
      // message bot a l'ouverture (dialogue = accroche + question client + reponse).
      if (!(trigger && trigger.seed)) state.pendingProactive = null;
      var _phKey = (trigger && trigger.placeholder_key) || "ph";
      var inp = el("input", { class: "ls-proactive-input", type: "text", placeholder: pi18n(_phKey, locale), "aria-label": pi18n(_phKey, locale) });
      var sendBtn = el("button", { class: "ls-proactive-send", type: "button", "aria-label": pi18n("send", locale) }, "➤");
      var submitInput = function (ev) {
        if (ev) { ev.stopPropagation(); ev.preventDefault(); }
        var v = (inp.value || "").trim();
        if (!v) { inp.focus(); return; }
        bubble.remove();
        openChat();
        setTimeout(function () { sendVisitorMessage(v); }, 300);
      };
      sendBtn.addEventListener("click", submitInput);
      inp.addEventListener("click", function (e) { e.stopPropagation(); });
      inp.addEventListener("keydown", function (e) { if (e.key === "Enter") submitInput(e); });
      controlsEl = el("div", { class: "ls-proactive-inputbar" }, [inp, sendBtn]);
    } else if (cta === "yesno") {
      // Fiche produit : Oui ! / Plus tard...
      var yesBtn = el("button", { class: "ls-proactive-chip ls-proactive-yes", type: "button" }, pi18n("yes", locale));
      var laterBtn = el("button", { class: "ls-proactive-chip ls-proactive-later", type: "button" }, pi18n("later", locale));
      yesBtn.addEventListener("click", function (ev) {
        ev.stopPropagation(); ev.preventDefault();
        state.pendingProactive = null;
        bubble.remove();
        openChat();
        setTimeout(function () { sendVisitorMessage(pi18n("sizehelp", locale) + " : " + location.href); }, 300);
      });
      laterBtn.addEventListener("click", function (ev) {
        ev.stopPropagation(); ev.preventDefault();
        state.pendingProactive = null;
        bubble.remove();
      });
      controlsEl = el("div", { class: "ls-proactive-chips" }, [yesBtn, laterBtn]);
    } else {
      // Accueil / défaut : les 3 raccourcis cliquables, LOCALISES (Arnaud 2026-06-01 : etaient en FR sur DE)
      var PROACTIVE_CHIPS = [
        { label: pi18n("chip_size", locale), msg: pi18n("chip_size", locale) },
        { label: pi18n("chip_promo", locale), msg: pi18n("chip_promo", locale) }
        // chip_return RETIRE (Arnaud 2026-06-19) : pas de promotion proactive du retour (facilite les retours)
      ];
      controlsEl = el("div", { class: "ls-proactive-chips" },
        PROACTIVE_CHIPS.map(function (c) {
          return el("button", {
            class: "ls-proactive-chip", type: "button",
            onclick: function (ev) {
              ev.stopPropagation();
              ev.preventDefault();
              state.pendingProactive = null;
              bubble.remove();
              openChat();
              setTimeout(function () { sendVisitorMessage(c.msg); }, 300);
            }
          }, c.label);
        })
      );
    }

    var bubble = el("div", { class: "ls-proactive-bubble", id: "ls-proactive-bubble" }, [
      el("button", { class: "ls-proactive-close", "aria-label": "Fermer", type: "button" }, "×"),
      el("div", { class: "ls-proactive-text" }, text),
      controlsEl,
    ]);
    fabRoot.appendChild(bubble);
    showBadge(1);

    // Close (×) : ferme la bulle SANS ouvrir le chat + annule le pending
    var closeBtn = bubble.querySelector(".ls-proactive-close");
    if (closeBtn) {
      closeBtn.addEventListener("click", function (ev) {
        ev.stopPropagation();
        ev.preventDefault();
        state.pendingProactive = null;
        bubble.remove();
      });
    }

    // Clic sur la bulle (texte) → ouvre le chat + injecte le message dedans + retire la bulle
    bubble.addEventListener("click", function (ev) {
      if (ev.target.closest(".ls-proactive-close")) return;
      ev.preventDefault();
      openChat();          // ouvre le panel (qui appelle consumeProactive)
      consumeProactive();  // filet sécurité si déjà ouvert
    });
  }


  // Neutralize Tidio if present (App Embed conflict - Tidio auto-closes when its launcher
  // is interfered with). Polls every 1s for 60s after load to catch late Tidio injection.
  function killTidioConflict() {
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      try {
        // Hide Tidio launcher iframe + close any open chat
        var tidioFrames = document.querySelectorAll('iframe[id^="tidio-chat"], iframe[src*="tidio"], iframe[title*="Tidio"]');
        tidioFrames.forEach(function (f) {
          f.style.display = "none";
          f.style.visibility = "hidden";
          f.style.pointerEvents = "none";
        });
        // Use Tidio API if loaded to fully disable
        if (window.tidioChatApi && typeof window.tidioChatApi.hide === "function") {
          window.tidioChatApi.hide();
        }
        if (window.tidioChatApi && typeof window.tidioChatApi.off === "function") {
          // remove their listeners
          try { window.tidioChatApi.off("open"); } catch(e){}
        }
      } catch (e) {}
      if (tries >= 60) clearInterval(timer);
    }, 1000);
  }

  // ===== CART ASSIST : ajoute la variante au panier en AJAX (reste dans le chat), fallback navigation =====
  var _CART_OK = { fr: "✓ Ajouté au panier", de: "✓ In den Warenkorb gelegt", at: "✓ In den Warenkorb gelegt", it: "✓ Aggiunto al carrello", es: "✓ Añadido a la cesta", nl: "✓ Toegevoegd aan winkelwagen", be: "✓ Ajouté au panier", ch: "✓ Ajouté au panier", uk: "✓ Added to cart", us: "✓ Added to cart", ca: "✓ Added to cart", dk: "✓ Added to cart", se: "✓ Added to cart" , pl: "✓ Dodano do koszyka" };
  var _CART_VIEW = { fr: "Voir mon panier", de: "Warenkorb ansehen", at: "Warenkorb ansehen", it: "Vedi carrello", es: "Ver cesta", nl: "Winkelwagen bekijken", be: "Voir mon panier", ch: "Voir mon panier", uk: "View cart", us: "View cart", ca: "View cart", dk: "View cart", se: "View cart" , pl: "Zobacz koszyk" };
  function addToCartAjax(variantId, qty, fallbackHref) {
    var origin = window.location.origin;
    var ck = _CART_OK[DETECTED_MARKET] || _CART_OK.uk;
    var cv = _CART_VIEW[DETECTED_MARKET] || _CART_VIEW.uk;
    fetch(origin + "/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: Number(variantId), quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error("add_" + r.status);
      return r.json();
    }).then(function (item) {
      var name = (item && (item.product_title || item.title)) || "";
      state.messages.push({ role: "assistant", content: ck + (name ? " : " + name : "") + " 🛒 [" + cv + "](" + origin + "/cart)" });
      try { persistSession(); } catch (e2) {}
      renderThread();
      // refresh UI panier du theme (best-effort, plusieurs conventions Shopify)
      try { document.dispatchEvent(new CustomEvent("cart:refresh")); } catch (e2) {}
      try { document.dispatchEvent(new CustomEvent("cart:build")); } catch (e2) {}
      try { fetch(origin + "/cart.js").then(function (c) { return c.json(); }).then(function (cart) { document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart })); }).catch(function () {}); } catch (e2) {}
    }).catch(function () {
      if (fallbackHref) window.location.href = fallbackHref;  // fallback : navigation panier classique
    });
  }

  // ===== Bloc 1 : comportement contextuel du widget (Arnaud 2026-06-01) =====
  // Masque le widget sur panier / checkout / thank_you + quand le drawer panier est ouvert.
  // Evite le bouton sticky "Ajouter au panier" en remontant le FAB. Tout est FAIL-SAFE :
  // si une detection echoue, le widget se comporte comme avant (jamais pire).
  function lsShouldHide() {
    var p = (location.pathname || "").toLowerCase();
    if (/\/cart(\/|$|\?)|\/checkout|\/thank|\/orders\//.test(p)) return true;
    return lsCartDrawerOpen();
  }
  // Detection ROBUSTE du drawer panier ouvert : par VISIBILITE reelle (un drawer ferme est
  // translate hors ecran -> getBoundingClientRect le reflete), independante du nom de classe du
  // theme (Aurora, Dawn, etc.). Arnaud 2026-06-02 : la bulle s'affichait par-dessus le panier UK.
  function _lsVisibleInVP(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    if (cs.display === "none" || cs.visibility === "hidden" || parseFloat(cs.opacity || "1") < 0.15) return false;
    var r = el.getBoundingClientRect();
    // panneau reellement visible : large + dans le viewport (un drawer ferme = translate hors ecran -> exclu)
    return r.width > 120 && r.height > 150 && r.left < window.innerWidth - 20 && r.right > 20 &&
           r.top < window.innerHeight && r.bottom > 0;
  }
  function lsCartDrawerOpen() {
    try {
      var sels = ["cart-drawer", "#CartDrawer", "#cart-drawer", ".cart-drawer", ".drawer--cart",
                  ".cart__drawer", "[data-cart-drawer]", ".js-cart-drawer", ".mini-cart", "#mini-cart",
                  ".side-cart", ".ajax-cart", "cart-notification"];
      var seen = [];
      for (var i = 0; i < sels.length; i++) {
        var el = document.querySelector(sels[i]);
        if (!el || seen.indexOf(el) >= 0) continue;
        seen.push(el);
        // 1. attribut/classe/aria d'ouverture explicite (Aurora & autres themes)
        var cls = (el.className || "").toString();
        if (el.hasAttribute("open") || el.getAttribute("aria-hidden") === "false" ||
            /(?:^|\s)(is-open|active|open|drawer--active|animate|js-active|is-visible|expanded)(?:\s|$)/.test(cls)) return true;
        // 2. l'element lui-meme a glisse dans le viewport
        if (_lsVisibleInVP(el)) return true;
        // 3. Aurora : contenu en <template>, rendu a l'ouverture -> un enfant non-template large+visible = ouvert
        //    (couvre le cas ou le wrapper <cart-drawer> reste fin mais le panneau interieur s'affiche)
        var kids = el.children;
        for (var k = 0; k < kids.length; k++) {
          var c = kids[k];
          if (c.tagName === "TEMPLATE" || c.tagName === "STYLE" || c.tagName === "SCRIPT") continue;
          if (_lsVisibleInVP(c)) return true;
        }
      }
      // 4. Aurora (Getwebcraft) : le backdrop `.body-overlay` plein-viewport passe de
      //    pointer-events:none (ferme) a auto (un sidebar/drawer s'ouvre). Signal fiable, theme-wide.
      var ovs = document.querySelectorAll(".body-overlay, [data-overlay].overlay, .drawer__overlay");
      for (var o = 0; o < ovs.length; o++) {
        var ov = ovs[o], co = getComputedStyle(ov);
        if (co.display === "none" || co.visibility === "hidden") continue;
        if (co.pointerEvents === "none") continue; // ferme = transparent + non cliquable
        var ro = ov.getBoundingClientRect();
        if (ro.width > window.innerWidth * 0.55 && ro.height > window.innerHeight * 0.5) return true;
      }
    } catch (e) {}
    return false;
  }
  function lsStickyAtcVisible() {
    try {
      var sc = document.querySelector("sticky-cart, .sticky-cart, .sticky-atc, .product-sticky, [data-sticky-cart], .sticky-add-to-cart");
      if (!sc) return false;
      var r = sc.getBoundingClientRect();
      return r.height > 4 && r.top < window.innerHeight && r.top > window.innerHeight * 0.4;
    } catch (e) { return false; }
  }
  function lsApplyContext() {
    var root = document.getElementById("ls-chat-root");
    if (!root) return;
    var hide = !state.open && lsShouldHide(); // jamais masquer si le chat est ouvert
    root.classList.toggle("ls-ctx-hidden", hide);
    root.classList.toggle("ls-avoid-atc", !hide && lsStickyAtcVisible());
  }
  function startContextController() {
    lsApplyContext();
    var ticking = false;
    window.addEventListener("scroll", function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { ticking = false; lsApplyContext(); });
    }, { passive: true });
    setInterval(lsApplyContext, 600);
    try {
      var mo = new MutationObserver(function () { lsApplyContext(); });
      mo.observe(document.body, { attributes: true, attributeFilter: ["class", "style", "open"] });
      var cd = document.querySelector("cart-drawer");
      if (cd) mo.observe(cd, { attributes: true, attributeFilter: ["class", "open"] });
    } catch (e) {}
  }

  // ============ RE-ENGAGEMENT (Arnaud 2026-06-02) : 5 min d'inactivite OU depart d'onglet ============
  // Message doux "Je suis la si besoin 👋" + (sur depart) alerte onglet : titre clignotant, badge
  // favicon, son, notification OS. Active UNIQUEMENT apres que le client a OUVERT le chat (engage),
  // pour ne pas embeter les visiteurs lambda. Scope widget, 100% reversible (titre/favicon restaures).
  var REENGAGE_I18N = { fr: "Je suis là si besoin 👋", en: "I'm here if you need me 👋", de: "Ich bin da, falls Sie etwas brauchen 👋", it: "Sono qui se le serve 👋", es: "Estoy aquí si necesita algo 👋", nl: "Ik ben er als je iets nodig hebt 👋", da: "Jeg er her, hvis du har brug for noget 👋", sv: "Jag finns här om du behöver 👋", pt: "Estou aqui se precisar 👋", pl: "Jestem tu, gdyby coś 👋", ru: "Я рядом, если что 👋", ja: "何かあればここにいます 👋", ko: "필요하시면 여기 있어요 👋", zh: "需要随时找我 👋", hr: "Tu sam ako treba 👋" };
  function _reMsg() { var l = detectLocale(); return REENGAGE_I18N[l] || REENGAGE_I18N.en; }
  var _reTimer = null, _reEngaged = false, _reEnabled = false, _reNotifAsked = false;
  var _reOrigTitle = null, _reTitleIv = null, _reOrigFav = null, _reAudioCtx = null;
  var REENGAGE_MS = 5 * 60 * 1000;

  function reArm() {           // (re)arme le timer d'inactivite + autorise une nouvelle relance
    if (!_reEnabled) return;
    _reEngaged = false;
    clearTimeout(_reTimer);
    _reTimer = setTimeout(function () { reShowMessage(); }, REENGAGE_MS);
  }
  function reEnable() {        // appele quand le client ouvre le chat (engagement)
    if (_reEnabled) return;
    _reEnabled = true;
    reUnlockAudio();
    reArm();
  }
  function _reShownOnce() { try { return localStorage.getItem("ls_reengaged_once") === "1"; } catch (e) { return false; } }
  function reShowMessage() {
    if (_reEngaged) return;
    if (_reShownOnce()) return;  // 🚫 1 SEUL "Je suis la si besoin" par client (Arnaud 2026-06-05 : spamait a CHAQUE changement d'onglet)
    if (typeof lsShouldHide === "function" && lsShouldHide()) return;  // pas pendant panier/checkout
    _reEngaged = true;
    try { localStorage.setItem("ls_reengaged_once", "1"); } catch (e) {}  // ne se redeclenche plus jamais pour ce client
    var msg = _reMsg();
    if (state.open) {
      state.messages.push({ role: "assistant", content: msg });
      try { renderThread(); } catch (e) {}
      try { scrollThread(); } catch (e) {}
    } else {
      try { showProactiveBubble({ name: "reengage", cta: "input", placeholder_key: "ph_q" }, msg); } catch (e) {}
    }
  }
  function reUnlockAudio() { try { var C = window.AudioContext || window.webkitAudioContext; if (C && !_reAudioCtx) { _reAudioCtx = new C(); } if (_reAudioCtx && _reAudioCtx.state === "suspended") { _reAudioCtx.resume(); } } catch (e) {} }
  function rePlayDing() { try { if (!_reAudioCtx) return; var ac = _reAudioCtx; if (ac.state === "suspended") ac.resume(); var note = function (f, t, d) { var o = ac.createOscillator(), g = ac.createGain(); o.connect(g); g.connect(ac.destination); o.type = "sine"; o.frequency.value = f; var s = ac.currentTime + t; g.gain.setValueAtTime(0.0001, s); g.gain.exponentialRampToValueAtTime(0.12, s + 0.02); g.gain.exponentialRampToValueAtTime(0.0001, s + d); o.start(s); o.stop(s + d + 0.02); }; note(880, 0, 0.35); note(1175, 0.18, 0.4); } catch (e) {} }
  function reFaviconBadge() { try {
    var link = document.querySelector("link[rel~='icon']");
    if (_reOrigFav === null) _reOrigFav = link ? (link.getAttribute("href") || "") : "";
    var c = document.createElement("canvas"); c.width = 64; c.height = 64; var x = c.getContext("2d");
    x.fillStyle = "#AEC628"; var r = 14;
    x.beginPath(); x.moveTo(r, 0); x.arcTo(64, 0, 64, 64, r); x.arcTo(64, 64, 0, 64, r); x.arcTo(0, 64, 0, 0, r); x.arcTo(0, 0, 64, 0, r); x.closePath(); x.fill();
    x.font = "32px -apple-system,Segoe UI Emoji,Arial"; x.textAlign = "center"; x.textBaseline = "middle"; x.fillText("💬", 30, 34);
    x.fillStyle = "#FF3B30"; x.beginPath(); x.arc(50, 14, 13, 0, 2 * Math.PI); x.fill();
    x.fillStyle = "#fff"; x.font = "bold 18px -apple-system,Arial"; x.fillText("1", 50, 15);
    var uri = c.toDataURL("image/png");
    if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
    link.setAttribute("href", uri);
  } catch (e) {} }
  function reRestoreFavicon() { try { if (_reOrigFav !== null) { var link = document.querySelector("link[rel~='icon']"); if (link) link.setAttribute("href", _reOrigFav || ""); } } catch (e) {} }
  function reStartTitleFlash() { try { if (_reTitleIv) return; if (_reOrigTitle === null) _reOrigTitle = document.title; var on = false; _reTitleIv = setInterval(function () { document.title = on ? _reOrigTitle : ("👋 " + _reMsg()); on = !on; }, 1200); } catch (e) {} }
  function reStopTitleFlash() { try { if (_reTitleIv) { clearInterval(_reTitleIv); _reTitleIv = null; } if (_reOrigTitle !== null) document.title = _reOrigTitle; } catch (e) {} }
  function reNotify() { try { if (("Notification" in window) && Notification.permission === "granted") { var n = new Notification("La Salopette 👋", { body: _reMsg(), tag: "ls-reengage", renotify: false }); n.onclick = function () { try { window.focus(); } catch (e) {} try { n.close(); } catch (e) {} try { openChat(); } catch (e) {} }; } } catch (e) {} }
  function reRequestNotif() { try { if (!_reNotifAsked && ("Notification" in window) && Notification.permission === "default") { _reNotifAsked = true; Notification.requestPermission().catch(function () {}); } } catch (e) {} }
  function reOnLeave() { if (!_reEnabled || _reShownOnce()) return; reShowMessage(); reStartTitleFlash(); reFaviconBadge(); rePlayDing(); reNotify(); }
  function reOnReturn() { reStopTitleFlash(); reRestoreFavicon(); reArm(); }
  document.addEventListener("visibilitychange", function () { if (document.hidden) reOnLeave(); else reOnReturn(); });

  function init() {
    if (document.getElementById("ls-chat-root")) return;
    loadSession();
    killTidioConflict();

    // Inject CSS UNIQUEMENT si le CSS n'est pas deja charge. 🚨 Sur la PROD, le theme.liquid charge deja
    // l'asset 'chat-widget.css' (recolore par theme : vert live / bleu ete). On NE DOIT PAS injecter en plus
    // le mirror Railway /widget.css (qui est theme-agnostique = VERT) sinon flash vert->bleu (Arnaud 2026-06-25).
    // -> on detecte AUSSI le <link ...chat-widget.css> du theme. Le sandbox (/tidio-chat) n'a pas ce lien -> fallback Railway.
    if (!document.querySelector('link[data-ls-chat="css"], link[href*="chat-widget.css"]')) {
      var link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = CFG.apiBase + "/widget.css";
      link.setAttribute("data-ls-chat", "css");
      document.head.appendChild(link);
    }

    var root = renderRoot();
    document.body.appendChild(root);

    // CART ASSIST : intercepte les clics sur un lien panier /cart/<id>:<qty> -> AJAX add (reste dans le chat)
    root.addEventListener("click", function (e) {
      var a = (e.target && e.target.closest) ? e.target.closest("a[href]") : null;
      if (!a) return;
      var m = (a.getAttribute("href") || "").match(/\/cart\/(\d+):(\d+)/);
      if (!m) return;
      e.preventDefault();
      addToCartAjax(m[1], parseInt(m[2], 10) || 1, a.getAttribute("href"));
    });

    // Show small badge if returning visitor with conversation
    if (state.messages.length > 0 && !state.open) {
      showBadge(1);
    }

    // Force initial view based on conversation state (auto-resume chat if any msg exists)
    if (state.messages.length > 0) {
      state.view = "chat";
    }

    // ESC key to close panel
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && state.open) toggleOpen();
    });

    // Click outside the panel (on the chat-root backdrop) to close - disabled on mobile to avoid accidental close
    // Tap on the close X is the primary close path. ESC = secondary. Click-outside = optional desktop.

    // PROACTIVE TRIGGERS : fire 1 trigger based on page URL (24h cooldown)
    fireProactiveTrigger();

    // Bloc 1 : masque le widget sur panier/checkout + evite le bouton Ajouter au panier
    startContextController();
    // Bloc 3 : beacon "vue de page" (alimente la map live + liste online Louise)
    lsRefreshCart(true);              // lit le panier (item_count) -> stage "cart" (rouge) si actif + re-beacon fiable des la reponse
    setTimeout(function () { lsBeacon("none"); }, 400); // 1er beacon rapide (cas sans panier) ; le re-beacon cart part des que /cart.js repond
    // Funnel : MAJ panier sur cart:updated + petit refresh periodique
    try { document.addEventListener("cart:updated", function (e) { var c = e && e.detail; _lsCartCount = (c && c.item_count != null) ? c.item_count : _lsCartCount; if (typeof lsRefreshCart === "function") lsRefreshCart(); setTimeout(function () { lsBeacon("none"); }, 700); }); } catch (e) {}
    setInterval(lsRefreshCart, 90000);
    // NOIR = initiate checkout : clic sur un bouton "Commander/Checkout/Payer" -> beacon stage=checkout
    try {
      document.addEventListener("click", function (ev) {
        var t = ev.target && ev.target.closest && ev.target.closest('[name="checkout"], button[name="checkout"], a[href*="/checkout"], .cart__checkout-button, .cart__checkout, [data-checkout], #checkout');
        if (t) { lsBeacon("none", "checkout"); }
      }, true);
    } catch (e) {}

    // NUDGE : petit clin d'oeil du launcher toutes les 15s quand le chat est FERME, juste pour
    // attirer l'oeil (Arnaud 2026-06-16). Gates : reduced-motion OFF + onglet visible + panel
    // ferme + pas de bulle proactive en cours (sinon ca surcharge). 0 cout (pure CSS cote client).
    try {
      var _reduceMotion = false;
      try { _reduceMotion = !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches); } catch (e) {}
      if (!_reduceMotion) {
        var _nudgeOffT = null;
        var _nudgeFab = function () {
          if (state.open) return;                                    // jamais quand le chat est ouvert
          if (document.hidden) return;                               // pas dans un onglet en arriere-plan
          if (document.getElementById("ls-proactive-bubble")) return; // pas par-dessus une bulle proactive
          var fab = document.getElementById("ls-fab");
          if (!fab) return;
          fab.classList.remove("ls-nudge");
          void fab.offsetWidth;                                      // reflow -> relance l'animation a coup sur
          fab.classList.add("ls-nudge");
          if (_nudgeOffT) clearTimeout(_nudgeOffT);
          _nudgeOffT = setTimeout(function () { fab.classList.remove("ls-nudge"); }, 1000);
        };
        setTimeout(_nudgeFab, 6000);     // 1er clin d'oeil ~6s apres l'arrivee (capte les visiteurs rapides)
        setInterval(_nudgeFab, 15000);   // puis toutes les 15s tant que le chat reste ferme
      }
    } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Expose minimal API for programmatic open (Arnaud A/B testing)
  window.LSChat = {
    open: function () { if (!state.open) toggleOpen(); },
    close: function () { if (state.open) toggleOpen(); },
    sendAsVisitor: sendVisitorMessage,
    setCustomerEmail: function (e) { state.customerEmail = e; }
  };
})();
